// API Documentation page i18n translations
// Keys prefixed with 'doc_' to avoid conflicts with existing translations

export const apiDocTranslations = {
  'zh-CN': {
    // Tab labels
    doc_tabDoc: 'API 文档',
    doc_tabOverview: 'API 总览',
    doc_tabDetail: 'API 详情',
    doc_tabGuide: '接入指南',
    doc_tabMatrix: '渠道能力',
    doc_tabAdmin: '配置管理',

    // Matrix stats
    doc_statChannels: '渠道',
    doc_statRegions: '区域',
    doc_statCurrencies: '币种',
    doc_statConfigurations: '配置项',
    doc_matrixSubtitle: '所有支付渠道的区域、币种和能力概览',
    doc_filterLabel: '筛选',

    // Filter bar
    doc_selectApi: '选择接口',
    doc_selectChannel: '选择渠道',
    doc_channelCount: (n) => `${n} 个渠道`,

    // API overview
    doc_totalApis: (n) => `共 ${n} 个接口，按业务模块分组展示，点击任意行查看详情`,
    doc_apiCount: (n) => `${n} 个接口`,
    doc_colMethod: '方法',
    doc_colPath: '接口路径',
    doc_colName: '名称',
    doc_colDesc: '说明',

    // Common response
    doc_commonResponse: '通用响应结构',
    doc_commonResponseDesc: '所有接口响应均遵循统一包装格式，业务数据在',
    doc_commonResponseDesc2: '字段中返回。',

    // Error codes
    doc_errorCodeLookup: '错误码速查',
    doc_colCategory: '分类',
    doc_colAction: '处理建议',

    // Detail columns
    doc_colField: '字段名',
    doc_colLabel: '标签',
    doc_colType: '类型',
    doc_colRequired: '必填',
    doc_colDescDetail: '说明',
    doc_yes: '是',
    doc_no: '否',
    doc_example: '示例',

    // Request/Response sections
    doc_requestParams: '请求参数',
    doc_extParamFields: 'extParam 差异字段',
    doc_noExtParam: '该渠道无额外 extParam 字段',
    doc_exampleRequest: '示例请求',
    doc_responseParams: '响应参数',
    doc_exampleResponse: '示例响应',
    doc_noConfig: '该渠道暂无配置',

    // Copy button
    doc_copy: '复制',
    doc_copied: '已复制',

    // Channel capability matrix
    doc_region: '区域',
    doc_channelType: '渠道类型',
    doc_channelCount2: (n) => `${n} 个渠道`,
    doc_dataSource: '数据来源',
    doc_colChannel: '渠道',
    doc_colType2: '类型',
    doc_colRegion: '区域',
    doc_colEntity: '主体',
    doc_colKeyFunction: '关键职能',
    doc_colCountry: '国家',
    doc_colCurrency: '币种',
    doc_colPaymentMethod: '支付方式',
    doc_colUserType: '用户类型',
    doc_userAll: '全部',
    doc_userBiz: '企业',
    doc_userIndividual: '个人',
    doc_colOpenAccount: '开户',
    doc_colDeposit: '充值',
    doc_colWithdraw: '提现',
    doc_colRefund: '退款',
    doc_colPartialRefund: '部分退款',
    doc_colSameNameVa: '同名VA',
    doc_capabilities: '能力支持',

    // Admin panel
    doc_addConfig: '新增配置',
    doc_refreshCache: '刷新缓存',
    doc_totalConfigs: (n) => `共 ${n} 条配置`,
    doc_totalPagination: (n) => `共 ${n} 条`,
    doc_editMeta: '编辑元数据',
    doc_addMeta: '新增元数据',
    doc_channelCodeLabel: '渠道代码',
    doc_apiNameLabel: 'API 名称',
    doc_descLabel: '描述',
    doc_fieldConfig: '字段配置 (JSON)',
    doc_fieldConfigExtra: 'JSON 数组格式，每个元素包含 name, label, type, required, group, options, placeholder, tip 等字段',
    doc_exampleRequestJson: '示例请求 (JSON)',
    doc_adminEdit: '编辑',
    doc_adminCopy: '复制',
    doc_adminDelete: '删除',
    doc_confirmDelete: '确认删除？',
    doc_adminChannel: '渠道',
    doc_adminStatus: '状态',
    doc_adminVersion: '版本',
    doc_adminCreator: '创建人',
    doc_adminAction: '操作',
    doc_loadFailed: '加载失败',
    doc_updateSuccess: '更新成功',
    doc_createSuccess: '创建成功',
    doc_jsonError: 'JSON 格式错误，请检查',
    doc_saveFailed: '保存失败',
    doc_deleteSuccess: '删除成功',
    doc_deleteFailed: '删除失败',
    doc_cacheRefreshed: '缓存刷新成功',
    doc_refreshFailed: '刷新失败',

    // SCENE_OPTIONS group labels
    doc_grpAccount: '账户',
    doc_grpBankAccount: '银行账户',
    doc_grpDeposit: '充值',
    doc_grpWithdraw: '提现',
    doc_grpRefund: '退款',
    doc_grpUser: '用户',
    doc_grpFile: '文件',
    doc_grpGeneral: '通用查询',

    // API labels (for SCENE_OPTIONS & API_CODE_LABELS)
    doc_apiAccountCreate: '开户',
    doc_apiAccountClose: '关户',
    doc_apiAccountQuery: '开户查询',
    doc_apiCardBind: '绑定银行账户',
    doc_apiCardQuery: '绑定银行账户查询',
    doc_apiCardUnbind: '解绑',
    doc_apiDepositCreate: '充值',
    doc_apiDepositQuery: '充值查询',
    doc_apiDepositClose: '充值关单',
    doc_apiDepositCapture: '充值请款',
    doc_apiRefundCreate: '退款',
    doc_apiRefundQuery: '退款查询',
    doc_apiWithdrawCreate: '提现',
    doc_apiWithdrawQuery: '提现查询',
    doc_apiChannelConfig: '渠道配置查询',
    doc_apiOrderPage: '订单列表',
    doc_apiBankList: '银行列表',
    doc_apiFileUpload: '文件上传',
    doc_apiFileStatusQuery: '文件状态查询',
    doc_apiUserCreate: '创建用户',
    doc_apiUserSupplement: '提交补充资料',
    doc_apiUserQuery: '查询用户',
    doc_apiBalanceQuery: '余额查询',
    doc_apiRateQuery: '汇率查询',
    doc_apiMmoList: 'Mobile Money 运营商列表',
    doc_apiPayoutRequirements: '走廊字段要求',

    // API descriptions
    doc_descAccountCreate: '为用户创建渠道账户（VA 或渠道账户）',
    doc_descAccountClose: '为用户关闭渠道账户',
    doc_descAccountQuery: '查询用户渠道账户信息',
    doc_descCardBind: '绑定银行账户',
    doc_descCardQuery: '查询绑定的银行账户信息',
    doc_descCardUnbind: '解绑银行账户',
    doc_descDepositCreate: '创建充值订单',
    doc_descDepositQuery: '查询充值订单结果',
    doc_descDepositClose: '关闭未完成的充值订单',
    doc_descDepositCapture: '买家授权后主动触发扣款（仅授权与扣款分离的渠道，如 PayPal）。'
      + '响应 captureResult 即本次请款结果，返回即可信、无需轮询；订单 status 因终态异步落库可能滞后',
    doc_descRefundCreate: '发起全额退款（仅部分渠道支持）',
    doc_descRefundQuery: '查询退款订单',
    doc_descWithdrawCreate: '创建提现订单',
    doc_descWithdrawQuery: '查询提现订单结果',
    doc_descChannelConfig: '查询渠道基础配置信息',
    doc_descOrderPage: '分页查询订单列表',
    doc_descBankList: '查询有效银行列表',
    doc_descFileUpload: '上传业务文件（KYC/EDD等），Content-Type: multipart/form-data',
    doc_descFileStatusQuery: '批量查询文件上传状态',
    doc_descUserCreate: '创建渠道用户（支持 PYVIO / TAZAPAY）',
    doc_descUserSupplement: '审核要求补件时提交补充文件（仅 TAZAPAY；不走创建/更新，走上传文件+挂载到 entity 等待复审）',
    doc_descUserQuery: '查询渠道用户详细信息',
    doc_descBalanceQuery: '查询渠道可用余额',
    doc_descRateQuery: '查询渠道汇率',
    doc_descMmoList: '根据渠道和币种查询对应国家的 Mobile Money 运营商（MMO）列表',
    doc_descPayoutRequirements: '查询指定走廊（国家+币种）的绑卡/提现字段要求，返回必填字段、推荐字段和转账限额',

    // Corridor Requirements Query panel
    doc_corridorTitle: '走廊字段要求查询',
    doc_corridorDesc: '选择国家和币种，查看该走廊绑卡所需的字段。推荐字段建议都传',
    doc_corridorCountry: '国家',
    doc_corridorCurrency: '币种',
    doc_corridorSelectCountry: '选择国家',
    doc_corridorSelectCurrency: '选择币种',
    doc_corridorSelectCountryFirst: '请先选择国家',
    doc_corridorRequired: '必填',
    doc_corridorRecommended: '推荐',
    doc_corridorMainFields: '主字段',
    doc_corridorExtFields: '扩展参数',
    doc_corridorNetworks: '清算网络',
    doc_corridorLimit: '限额',
    doc_corridorLoading: '查询中...',
    doc_corridorFieldsHint: '以下字段根据走廊动态返回，标记为必填的字段在绑卡时必须传入。',
    doc_corridorPayoutType: '付款类型',

    // Error categories
    doc_catSuccess: '成功',
    doc_catClient: '参数错误',
    doc_catSignature: '签名错误',
    doc_catVerification: '验证错误',
    doc_catRisk: '风控',
    doc_catSystem: '系统/渠道',

    // Error code descriptions
    doc_err000000: '成功',
    doc_err000000Action: '无需处理',
    doc_err400001: '参数无效: {param}',
    doc_err400001Action: '检查请求参数格式和取值范围',
    doc_err400002: '缺少必填参数: {param}',
    doc_err400002Action: '补充缺失的必填参数',
    doc_err400003: '请求被限流',
    doc_err400003Action: '降低请求频率，稍后重试',
    doc_err400004: '资源不存在: {resourceId}',
    doc_err400004Action: '确认资源 ID 是否正确',
    doc_err400005: '不支持的操作: {operation}',
    doc_err400005Action: '检查接口是否支持该操作',
    doc_err400006: '重复请求',
    doc_err400006Action: '更换 requestId 或 externalOrderId',
    doc_err400201: '签名验证失败: {reason}',
    doc_err400201Action: '检查签名算法(SHA384withECDSA)、密钥和签名串拼接',
    doc_err400301: '姓名验证失败: {reason}',
    doc_err400301Action: '确认姓名信息是否正确',
    doc_err400401: '风控拒绝: {reason}',
    doc_err400401Action: '查看 reason 详情，调整业务参数后重试',
    doc_err400402: '风控处理失败: {reason}',
    doc_err400402Action: '联系技术支持排查风控规则',
    doc_err500001: '系统内部错误',
    doc_err500001Action: '联系技术支持',
    doc_err500002: '渠道不可用: {channel}',
    doc_err500002Action: '确认渠道状态或联系管理员',
    doc_err500003: '服务暂时不可用',
    doc_err500003Action: '稍后重试',
    doc_err500004: '渠道超时: {channel}',
    doc_err500004Action: '稍后重试或查询订单状态',
    doc_err500005: '渠道配置错误: {channel}',
    doc_err500005Action: '联系管理员检查渠道配置',
    doc_err500006: '渠道响应无效: {channel}',
    doc_err500006Action: '联系技术支持排查渠道响应',
    doc_err500007: '渠道限流: {channel}',
    doc_err500007Action: '降低请求频率，稍后重试',
    doc_err500008: '渠道响应失败: {channel}',
    doc_err500008Action: '查看 errorMsg 获取渠道侧错误详情',
    doc_err500009: '与渠道通信网络错误: {channel}',
    doc_err500009Action: '稍后重试',
    doc_err500010: '渠道 JSON 响应解析失败: {channel}',
    doc_err500010Action: '联系技术支持排查渠道响应格式',

    // Guide tab
    doc_guideIntro: '本指南基于 Fiat Payment Open API v1 规范，帮助业务方完成从环境准备到生产上线的全流程接入。',
    doc_guideS1Title: '环境与网络',
    doc_guideS1Env: '环境',
    doc_guideS1Endpoint: 'API Endpoint',
    doc_guideS1CnLine: '中国大陆专线',
    doc_guideS1ContentType: 'Content-Type',
    doc_guideS1Timestamp: '时间戳: Unix Epoch Milliseconds (UTC)',
    doc_guideS1Whitelist: '业务方需提供出口 IP 用于白名单配置；Webhook 来源 IP: 3.78.97.230 / 3.123.207.216',
    doc_guideS2Title: 'API 认证 Headers',
    doc_guideS2Desc: '所有请求必须携带以下 Header：',
    doc_guideS2Required: '必填',
    doc_guideS2AppIdDesc: '分配的应用标识（API Key）',
    doc_guideS2TimestampDesc: 'Unix Epoch 毫秒时间戳 (UTC)',
    doc_guideS2SignatureDesc: 'Base64 编码的 ECC-SHA384withECDSA 签名',
    doc_guideS2Warning: 'timestamp 允许偏移 ±5 分钟，超出将返回签名时间错误。appId 必须安全存储，禁止泄露。',
    doc_guideS3Title: '签名机制 (ECC-SHA384withECDSA)',
    doc_guideS3Desc: 'Fiat Channel 采用',
    doc_guideS3ECC: 'ECC 椭圆曲线',
    doc_guideS3Desc2: '签名（非 RSA），算法为',
    doc_guideS3Desc3: '。系统使用两套独立密钥体系：',
    doc_guideS3MerchantKey: '商户密钥对',
    doc_guideS3MerchantPriv: '私钥 → 商户持有，签名 API 请求',
    doc_guideS3MerchantPub: '公钥 → 提供给 Fiat Channel 验签',
    doc_guideS3WebhookKey: '平台 Webhook 密钥对',
    doc_guideS3WebhookPriv: '私钥 → Fiat Channel 持有，签名 Webhook',
    doc_guideS3WebhookPub: '公钥 → 提供给商户验签',
    doc_guideS3Plaintext: '签名原文 (Plaintext)',
    doc_guideS3BodyRule: 'bodyJsonString 序列化规则（必须一致）',
    doc_guideS3BodyDesc: '字段按字典序排列，null 值不参与序列化。推荐 Jackson 配置：',
    doc_guideS3KeyGen: '密钥生成命令',
    doc_guideS3KeyNote: 'ECC 仅用于数字签名，不用于接口数据加密。',

    doc_guideS4Title: '金额与币种规范',
    doc_guideS4Desc: '所有金额必须以精确到小数点后',
    doc_guideS4Two: '两位',
    doc_guideS4Desc2: '的十进制字符串表示，适用于所有币种（含 IDR / JPY / KRW）。API 不会自动四舍五入。',
    doc_guideS4Rule: '规则',
    doc_guideS4NoSci: '不允许科学计数法',
    doc_guideS4NoComma: '不允许千分位',
    doc_guideS4UseDot: '使用 . 作为小数点',
    doc_guideS4NoTrail: '不允许尾随空格',
    doc_guideS4NoExtra: '不允许多余小数位',
    doc_guideS4ExceedPrecision: '超出精度 ❌',
    doc_guideS5Title: '统一响应模型',
    doc_guideS5Field: '字段',
    doc_guideS5Type: '类型',
    doc_guideS5Desc: '说明',
    doc_guideS5CodeDesc: 'HTTP 业务状态码',
    doc_guideS5SubCodeDesc: '6 位业务错误码，000000 = 成功',
    doc_guideS5MsgDesc: '英文错误描述',
    doc_guideS5TimeDesc: '请求时间 (epoch ms)',
    doc_guideS5ReqIdDesc: '请求唯一标识',
    doc_guideS5DataDesc: '返回数据',
    doc_guideS6Title: '错误码速查',
    doc_guideS6ErrCode: '错误码',
    doc_guideS6Desc: '说明',
    doc_guideS6Action: '处理建议',
    doc_guideS6Success: '请求成功',
    doc_guideS6SuccessAction: '—',
    doc_guideS6Client: '客户端错误（参数/格式）',
    doc_guideS6ClientAction: '不可重试，检查入参',
    doc_guideS6Sign: '签名相关错误',
    doc_guideS6SignAction: '检查签名实现与时间戳',
    doc_guideS6System: '系统或渠道错误',
    doc_guideS6SystemAction: '可重试',

    doc_guideS7Title: 'Webhook 回调',
    doc_guideS7Desc: '业务方需提供 HTTPS POST 接口接收异步通知。Webhook Header 包含签名信息：',
    doc_guideS7Verify: '验签逻辑：使用 Fiat Channel 提供的 Webhook 公钥验证 body 签名。',
    doc_guideS7Warning: '未通过验签的 Webhook 必须拒绝处理。线下入金渠道需额外提供默认 Callback URL（Sandbox / Production 各一个）。',
    doc_guideS8Title: '接入 Checklist',
    doc_guideS8CheckItem: '检查项',
    doc_guideS8Cat: '分类',
    doc_guideS8CatEnv: '环境',
    doc_guideS8CatAuth: '认证',
    doc_guideS8CatSign: '签名',
    doc_guideS8CatCallback: '回调',
    doc_guideS8CatBiz: '业务',
    doc_guideS8Items: [
      { item: '网络打通（Sandbox + Production）', cat: '环境' },
      { item: 'API Key (appId) 配置', cat: '认证' },
      { item: 'ECC 密钥对生成 & 公钥交换', cat: '签名' },
      { item: '签名原文拼接 & SHA384withECDSA 签名验证通过', cat: '签名' },
      { item: 'bodyJsonString 序列化规则一致（字典序 + NON_NULL）', cat: '签名' },
      { item: 'Webhook 接口开发 & 验签逻辑', cat: '回调' },
      { item: 'Fiat Channel Webhook 公钥保存', cat: '回调' },
      { item: '金额精度校验（2 位小数，无科学计数法）', cat: '业务' },
      { item: 'requestId 幂等性保证', cat: '业务' },
      { item: 'timestamp ±5min 时间窗口校验', cat: '业务' },
      { item: '默认 callbackUrl 提供（线下入金）', cat: '回调' },
    ],
    doc_guideS9Title: '推荐接入流程',
    doc_guideS9Steps: [
      { step: '环境准备', desc: '网络打通、出口 IP 白名单配置' },
      { step: '密钥交换', desc: '生成 ECC 密钥对，交换公钥' },
      { step: 'API Key 分配', desc: '获取 appId，配置 Header' },
      { step: 'Sandbox 开发', desc: '实现签名、接口调用、Webhook 接收' },
      { step: 'Sandbox 联调', desc: '全场景功能验证 & 签名验证' },
      { step: 'Production 配置', desc: '切换 Endpoint、更新密钥与 callbackUrl' },
      { step: '生产上线', desc: '灰度验证 → 全量放开' },
    ],

    doc_guideS10Title: '信息交换清单',
    doc_guideS10FiatProvides: 'Fiat Channel 提供',
    doc_guideS10FiatItems: ['API Endpoint (Sandbox + Prod)', 'appId (API Key)', 'Webhook ECC 公钥', 'Webhook 来源 IP'],
    doc_guideS10BizProvides: '业务方提供',
    doc_guideS10BizItems: ['出口 IP（用于白名单）', 'ECC 公钥（用于请求验签）', 'Webhook 接收 URL', '默认 Callback URL（线下入金）'],

    // Webhook Tab
    doc_tabWebhook: 'Webhook 回调',
    doc_webhookTitle: 'Webhook 异步回调',
    doc_webhookSubtitle: '当交易状态发生变化时，Fiat Payment 平台会通过 Webhook 异步通知商户。',
    doc_webhookSecurity: 'Webhook 安全',
    doc_webhookSecurityDesc1: 'Webhook 消息由 Fiat Payment 平台私钥签名',
    doc_webhookSecurityDesc2: '商户需使用平台公钥进行验签',
    doc_webhookSecurityDesc3: 'Webhook 消息签名但不加密',
    doc_webhookRetry: '重试机制',
    doc_webhookRetryDesc: '最大重试次数：5 次，采用指数退避策略',
    doc_webhookRetryWarning: '请确保 Webhook 接口幂等，避免重复处理。返回 HTTP 200 表示接收成功，否则将触发重试。',
    doc_webhookRequestBody: 'Webhook 请求体',
    doc_webhookFieldMsgId: 'Webhook 消息唯一 ID',
    doc_webhookFieldEventType: '事件类型',
    doc_webhookFieldVersion: '消息版本，固定 1.0.0',
    doc_webhookFieldData: '业务数据（JSON 字符串），结构因 eventType 而异',
    doc_webhookEventTypes: '事件类型说明',
    doc_webhookEventAccount: '开户',
    doc_webhookEventCard: '绑定银行账户',
    doc_webhookEventDeposit: '充值',
    doc_webhookEventWithdraw: '提现',
    doc_webhookEventRefund: '退款',
    doc_webhookEventUser: '用户创建',
    doc_webhookDataStructure: 'data 结构',
    doc_webhookSelectEvent: '选择事件类型查看 data 结构',
    doc_webhookFieldName: '参数名',
    doc_webhookFieldType: '类型',
    doc_webhookFieldRequired: '必须',
    doc_webhookFieldDesc: '描述',
    doc_webhookVerifyTitle: '验签说明',
    doc_webhookVerifyDesc: '使用 Fiat Channel 提供的 Webhook 公钥，对 body 内容进行 SHA384withECDSA 验签。',
    doc_webhookVerifyWarning: '未通过验签的 Webhook 必须拒绝处理。',
    doc_webhookHeaderDesc: 'Webhook 请求 Header 包含签名信息：',
    doc_webhookExample: '示例',
  },

  'en-US': {
    // Tab labels
    doc_tabDoc: 'API Docs',
    doc_tabOverview: 'API Overview',
    doc_tabDetail: 'API Details',
    doc_tabGuide: 'Integration Guide',
    doc_tabMatrix: 'Channel Capability',
    doc_tabAdmin: 'Config Management',

    // Matrix stats
    doc_statChannels: 'Channels',
    doc_statRegions: 'Regions',
    doc_statCurrencies: 'Currencies',
    doc_statConfigurations: 'Configurations',
    doc_matrixSubtitle: 'Overview of all payment channels, supported regions, currencies, and capabilities',
    doc_filterLabel: 'Filters',

    // Filter bar
    doc_selectApi: 'Select API',
    doc_selectChannel: 'Select Channel',
    doc_channelCount: (n) => `${n} channels`,

    // API overview
    doc_totalApis: (n) => `${n} APIs in total, grouped by module. Click any row for details`,
    doc_apiCount: (n) => `${n} APIs`,
    doc_colMethod: 'Method',
    doc_colPath: 'Endpoint',
    doc_colName: 'Name',
    doc_colDesc: 'Description',

    // Common response
    doc_commonResponse: 'Common Response Structure',
    doc_commonResponseDesc: 'All API responses follow a unified wrapper format. Business data is returned in the',
    doc_commonResponseDesc2: 'field.',

    // Error codes
    doc_errorCodeLookup: 'Error Code Reference',
    doc_colCategory: 'Category',
    doc_colAction: 'Suggested Action',

    // Detail columns
    doc_colField: 'Field',
    doc_colLabel: 'Label',
    doc_colType: 'Type',
    doc_colRequired: 'Required',
    doc_colDescDetail: 'Description',
    doc_yes: 'Yes',
    doc_no: 'No',
    doc_example: 'Example',

    // Request/Response sections
    doc_requestParams: 'Request Parameters',
    doc_extParamFields: 'extParam Diff Fields',
    doc_noExtParam: 'No additional extParam fields for this channel',
    doc_exampleRequest: 'Example Request',
    doc_responseParams: 'Response Parameters',
    doc_exampleResponse: 'Example Response',
    doc_noConfig: 'No configuration for this channel',

    // Copy button
    doc_copy: 'Copy',
    doc_copied: 'Copied',

    // Channel capability matrix
    doc_region: 'Region',
    doc_channelType: 'Channel Type',
    doc_channelCount2: (n) => `${n} channels`,
    doc_dataSource: 'Data source',
    doc_colChannel: 'Channel',
    doc_colType2: 'Type',
    doc_colRegion: 'Region',
    doc_colEntity: 'Entity',
    doc_colKeyFunction: 'Key Function',
    doc_colCountry: 'Country',
    doc_colCurrency: 'Currency',
    doc_colPaymentMethod: 'Payment Method',
    doc_colUserType: 'User Type',
    doc_userAll: 'All',
    doc_userBiz: 'Business',
    doc_userIndividual: 'Individual',
    doc_colOpenAccount: 'Account',
    doc_colDeposit: 'Deposit',
    doc_colWithdraw: 'Withdraw',
    doc_colRefund: 'Refund',
    doc_colPartialRefund: 'Partial Refund',
    doc_colSameNameVa: 'Same Name VA',
    doc_capabilities: 'Capabilities',

    // Admin panel
    doc_addConfig: 'Add Config',
    doc_refreshCache: 'Refresh Cache',
    doc_totalConfigs: (n) => `${n} configs total`,
    doc_totalPagination: (n) => `Total ${n}`,
    doc_editMeta: 'Edit Metadata',
    doc_addMeta: 'Add Metadata',
    doc_channelCodeLabel: 'Channel Code',
    doc_apiNameLabel: 'API Name',
    doc_descLabel: 'Description',
    doc_fieldConfig: 'Field Config (JSON)',
    doc_fieldConfigExtra: 'JSON array format, each element contains name, label, type, required, group, options, placeholder, tip fields',
    doc_exampleRequestJson: 'Example Request (JSON)',
    doc_adminEdit: 'Edit',
    doc_adminCopy: 'Copy',
    doc_adminDelete: 'Delete',
    doc_confirmDelete: 'Confirm delete?',
    doc_adminChannel: 'Channel',
    doc_adminStatus: 'Status',
    doc_adminVersion: 'Version',
    doc_adminCreator: 'Creator',
    doc_adminAction: 'Action',
    doc_loadFailed: 'Load failed',
    doc_updateSuccess: 'Updated successfully',
    doc_createSuccess: 'Created successfully',
    doc_jsonError: 'Invalid JSON format, please check',
    doc_saveFailed: 'Save failed',
    doc_deleteSuccess: 'Deleted successfully',
    doc_deleteFailed: 'Delete failed',
    doc_cacheRefreshed: 'Cache refreshed successfully',
    doc_refreshFailed: 'Refresh failed',

    // SCENE_OPTIONS group labels
    doc_grpAccount: 'Account',
    doc_grpBankAccount: 'Bank Account',
    doc_grpDeposit: 'Deposit',
    doc_grpWithdraw: 'Withdraw',
    doc_grpRefund: 'Refund',
    doc_grpUser: 'User',
    doc_grpFile: 'File',
    doc_grpGeneral: 'General Query',

    // API labels
    doc_apiAccountCreate: 'Account Create',
    doc_apiAccountClose: 'Account Close',
    doc_apiAccountQuery: 'Account Query',
    doc_apiCardBind: 'Bank Account Bind',
    doc_apiCardQuery: 'Bank Account Query',
    doc_apiCardUnbind: 'Unbind',
    doc_apiDepositCreate: 'Deposit',
    doc_apiDepositQuery: 'Deposit Query',
    doc_apiDepositClose: 'Deposit Close',
    doc_apiDepositCapture: 'Capture Payment',
    doc_apiRefundCreate: 'Refund',
    doc_apiRefundQuery: 'Refund Query',
    doc_apiWithdrawCreate: 'Withdraw',
    doc_apiWithdrawQuery: 'Withdraw Query',
    doc_apiChannelConfig: 'Channel Config Query',
    doc_apiOrderPage: 'Order List',
    doc_apiBankList: 'Bank List',
    doc_apiFileUpload: 'File Upload',
    doc_apiFileStatusQuery: 'File Status Query',
    doc_apiUserCreate: 'Create User',
    doc_apiUserSupplement: 'Submit Supplement Document',
    doc_apiUserQuery: 'Query User',
    doc_apiBalanceQuery: 'Balance Query',
    doc_apiRateQuery: 'Rate Query',
    doc_apiMmoList: 'Mobile Money Operators',
    doc_apiPayoutRequirements: 'Payout Requirements',

    // API descriptions
    doc_descAccountCreate: 'Create channel account for user (VA or channel account)',
    doc_descAccountClose: 'Close channel account for user',
    doc_descAccountQuery: 'Query user channel account info',
    doc_descCardBind: 'Bind bank account',
    doc_descCardQuery: 'Query bound bank account info',
    doc_descCardUnbind: 'Unbind bank account',
    doc_descDepositCreate: 'Create deposit order',
    doc_descDepositQuery: 'Query deposit order result',
    doc_descDepositClose: 'Close an incomplete deposit order',
    doc_descDepositCapture: 'Trigger capture after the buyer authorizes (only for channels that separate '
      + 'authorization from capture, e.g. PayPal). The captureResult field is the outcome of this capture - '
      + 'reliable on return, no polling needed; the order status may lag as the final state is persisted asynchronously',
    doc_descRefundCreate: 'Initiate full refund (supported by some channels)',
    doc_descRefundQuery: 'Query refund order',
    doc_descWithdrawCreate: 'Create withdrawal order',
    doc_descWithdrawQuery: 'Query withdrawal order result',
    doc_descChannelConfig: 'Query channel basic configuration',
    doc_descOrderPage: 'Paginated order list query',
    doc_descBankList: 'Query active bank list',
    doc_descFileUpload: 'Upload business files (KYC/EDD etc.), Content-Type: multipart/form-data',
    doc_descFileStatusQuery: 'Batch query file upload status',
    doc_descUserCreate: 'Create channel user (supports PYVIO / TAZAPAY)',
    doc_descUserSupplement: 'Submit supplement documents when review requires action (TAZAPAY only; not via create/update, but upload file + attach to entity for re-review)',
    doc_descUserQuery: 'Query channel user details',
    doc_descBalanceQuery: 'Query channel available balance',
    doc_descRateQuery: 'Query channel exchange rate',
    doc_descMmoList: 'Query the Mobile Money Operator (MMO) list for the corresponding country by channel and currency',
    doc_descPayoutRequirements: 'Query required fields, recommended fields and transfer limits for a given corridor (country + currency)',

    // Corridor Requirements Query panel
    doc_corridorTitle: 'Corridor Requirements',
    doc_corridorDesc: 'Select country and currency to check required fields for this corridor.',
    doc_corridorCountry: 'Country',
    doc_corridorCurrency: 'Currency',
    doc_corridorSelectCountry: 'Select Country',
    doc_corridorSelectCurrency: 'Select Currency',
    doc_corridorSelectCountryFirst: 'Select country first',
    doc_corridorRequired: 'Required',
    doc_corridorRecommended: 'Recommended',
    doc_corridorMainFields: 'Main Fields',
    doc_corridorExtFields: 'extParam Fields',
    doc_corridorNetworks: 'Networks',
    doc_corridorLimit: 'Limit',
    doc_corridorLoading: 'Loading...',
    doc_corridorFieldsHint: 'Fields below are dynamically determined by corridor. Required fields must be provided when binding.',
    doc_corridorPayoutType: 'Payout Type',

    // Error categories
    doc_catSuccess: 'Success',
    doc_catClient: 'Parameter',
    doc_catSignature: 'Signature',
    doc_catVerification: 'Verification',
    doc_catRisk: 'Risk Control',
    doc_catSystem: 'System/Channel',

    // Error code descriptions
    doc_err000000: 'Success',
    doc_err000000Action: 'No action needed',
    doc_err400001: 'Invalid parameter: {param}',
    doc_err400001Action: 'Check request parameter format and value range',
    doc_err400002: 'Missing required parameter: {param}',
    doc_err400002Action: 'Provide the missing required parameter',
    doc_err400003: 'Request is rate limited',
    doc_err400003Action: 'Reduce request frequency, retry later',
    doc_err400004: 'Resource not found: {resourceId}',
    doc_err400004Action: 'Verify the resource ID is correct',
    doc_err400005: 'Unsupported operation: {operation}',
    doc_err400005Action: 'Check if the API supports this operation',
    doc_err400006: 'Duplicate request',
    doc_err400006Action: 'Use a different requestId or externalOrderId',
    doc_err400201: 'Signature verification failed: {reason}',
    doc_err400201Action: 'Check signing algorithm (SHA384withECDSA), keys and sign string',
    doc_err400301: 'Name verification failed: {reason}',
    doc_err400301Action: 'Verify the name information is correct',
    doc_err400401: 'Risk control rejected: {reason}',
    doc_err400401Action: 'Check reason details, adjust parameters and retry',
    doc_err400402: 'Risk control failed: {reason}',
    doc_err400402Action: 'Contact technical support to investigate risk rules',
    doc_err500001: 'Internal server error',
    doc_err500001Action: 'Contact technical support',
    doc_err500002: 'Channel unavailable: {channel}',
    doc_err500002Action: 'Confirm channel status or contact admin',
    doc_err500003: 'Service temporarily unavailable',
    doc_err500003Action: 'Retry later',
    doc_err500004: 'Channel timeout: {channel}',
    doc_err500004Action: 'Retry later or query order status',
    doc_err500005: 'Channel configuration error: {channel}',
    doc_err500005Action: 'Contact admin to check channel configuration',
    doc_err500006: 'Invalid response from channel: {channel}',
    doc_err500006Action: 'Contact technical support to investigate channel response',
    doc_err500007: 'Channel rate limited: {channel}',
    doc_err500007Action: 'Reduce request frequency, retry later',
    doc_err500008: 'Channel response failed: {channel}',
    doc_err500008Action: 'Check errorMsg for channel-side error details',
    doc_err500009: 'Network error with channel: {channel}',
    doc_err500009Action: 'Retry later',
    doc_err500010: 'Failed to parse JSON response from channel: {channel}',
    doc_err500010Action: 'Contact technical support to investigate response format',

    // Guide tab
    doc_guideIntro: 'This guide is based on the Fiat Payment Open API v1 specification, helping integrators complete the full process from environment setup to production launch.',
    doc_guideS1Title: 'Environment & Network',
    doc_guideS1Env: 'Environment',
    doc_guideS1Endpoint: 'API Endpoint',
    doc_guideS1CnLine: 'China Mainland Dedicated Line',
    doc_guideS1ContentType: 'Content-Type',
    doc_guideS1Timestamp: 'Timestamp: Unix Epoch Milliseconds (UTC)',
    doc_guideS1Whitelist: 'Integrators must provide egress IP for whitelist configuration; Webhook source IP: 3.78.97.230 / 3.123.207.216',
    doc_guideS2Title: 'API Authentication Headers',
    doc_guideS2Desc: 'All requests must include the following Headers:',
    doc_guideS2Required: 'Required',
    doc_guideS2AppIdDesc: 'Assigned application identifier (API Key)',
    doc_guideS2TimestampDesc: 'Unix Epoch millisecond timestamp (UTC)',
    doc_guideS2SignatureDesc: 'Base64-encoded ECC-SHA384withECDSA signature',
    doc_guideS2Warning: 'Timestamp allows ±5 minute offset; exceeding this returns a signature time error. appId must be stored securely and never exposed.',
    doc_guideS3Title: 'Signing Mechanism (ECC-SHA384withECDSA)',
    doc_guideS3Desc: 'Fiat Channel uses',
    doc_guideS3ECC: 'ECC Elliptic Curve',
    doc_guideS3Desc2: 'signing (not RSA), algorithm:',
    doc_guideS3Desc3: '. The system uses two independent key pairs:',
    doc_guideS3MerchantKey: 'Merchant Key Pair',
    doc_guideS3MerchantPriv: 'Private key → Held by merchant, signs API requests',
    doc_guideS3MerchantPub: 'Public key → Provided to Fiat Channel for verification',
    doc_guideS3WebhookKey: 'Platform Webhook Key Pair',
    doc_guideS3WebhookPriv: 'Private key → Held by Fiat Channel, signs Webhooks',
    doc_guideS3WebhookPub: 'Public key → Provided to merchant for verification',
    doc_guideS3Plaintext: 'Signature Plaintext',
    doc_guideS3BodyRule: 'bodyJsonString Serialization Rules (must be consistent)',
    doc_guideS3BodyDesc: 'Fields sorted alphabetically, null values excluded. Recommended Jackson config:',
    doc_guideS3KeyGen: 'Key Generation Command',
    doc_guideS3KeyNote: 'ECC is used for digital signatures only, not for data encryption.',

    doc_guideS4Title: 'Amount & Currency Rules',
    doc_guideS4Desc: 'All amounts must be represented as decimal strings with exactly',
    doc_guideS4Two: 'two',
    doc_guideS4Desc2: 'decimal places, applicable to all currencies (including IDR / JPY / KRW). The API does not auto-round.',
    doc_guideS4Rule: 'Rule',
    doc_guideS4NoSci: 'No scientific notation',
    doc_guideS4NoComma: 'No thousands separator',
    doc_guideS4UseDot: 'Use . as decimal point',
    doc_guideS4NoTrail: 'No trailing spaces',
    doc_guideS4NoExtra: 'No extra decimal places',
    doc_guideS4ExceedPrecision: 'Exceeds precision ❌',
    doc_guideS5Title: 'Unified Response Model',
    doc_guideS5Field: 'Field',
    doc_guideS5Type: 'Type',
    doc_guideS5Desc: 'Description',
    doc_guideS5CodeDesc: 'HTTP business status code',
    doc_guideS5SubCodeDesc: '6-digit business error code, 000000 = success',
    doc_guideS5MsgDesc: 'English error description',
    doc_guideS5TimeDesc: 'Request time (epoch ms)',
    doc_guideS5ReqIdDesc: 'Unique request identifier',
    doc_guideS5DataDesc: 'Response data',
    doc_guideS6Title: 'Error Code Reference',
    doc_guideS6ErrCode: 'Error Code',
    doc_guideS6Desc: 'Description',
    doc_guideS6Action: 'Suggested Action',
    doc_guideS6Success: 'Request successful',
    doc_guideS6SuccessAction: '—',
    doc_guideS6Client: 'Client error (params/format)',
    doc_guideS6ClientAction: 'Non-retryable, check input',
    doc_guideS6Sign: 'Signature-related error',
    doc_guideS6SignAction: 'Check signing implementation and timestamp',
    doc_guideS6System: 'System or channel error',
    doc_guideS6SystemAction: 'Retryable',

    doc_guideS7Title: 'Webhook Callbacks',
    doc_guideS7Desc: 'Integrators must provide an HTTPS POST endpoint to receive async notifications. Webhook Headers contain signature info:',
    doc_guideS7Verify: 'Verification: Use the Fiat Channel Webhook public key to verify the body signature.',
    doc_guideS7Warning: 'Webhooks that fail verification must be rejected. Offline deposit channels require a default Callback URL (one each for Sandbox / Production).',
    doc_guideS8Title: 'Integration Checklist',
    doc_guideS8CheckItem: 'Check Item',
    doc_guideS8Cat: 'Category',
    doc_guideS8CatEnv: 'Env',
    doc_guideS8CatAuth: 'Auth',
    doc_guideS8CatSign: 'Sign',
    doc_guideS8CatCallback: 'Callback',
    doc_guideS8CatBiz: 'Business',
    doc_guideS8Items: [
      { item: 'Network connectivity (Sandbox + Production)', cat: 'Env' },
      { item: 'API Key (appId) configuration', cat: 'Auth' },
      { item: 'ECC key pair generation & public key exchange', cat: 'Sign' },
      { item: 'Signature plaintext assembly & SHA384withECDSA verification passed', cat: 'Sign' },
      { item: 'bodyJsonString serialization rules consistent (alphabetical + NON_NULL)', cat: 'Sign' },
      { item: 'Webhook endpoint development & verification logic', cat: 'Callback' },
      { item: 'Fiat Channel Webhook public key saved', cat: 'Callback' },
      { item: 'Amount precision validation (2 decimals, no scientific notation)', cat: 'Business' },
      { item: 'requestId idempotency guarantee', cat: 'Business' },
      { item: 'timestamp ±5min time window validation', cat: 'Business' },
      { item: 'Default callbackUrl provided (offline deposit)', cat: 'Callback' },
    ],
    doc_guideS9Title: 'Recommended Integration Flow',
    doc_guideS9Steps: [
      { step: 'Environment Setup', desc: 'Network connectivity, egress IP whitelist configuration' },
      { step: 'Key Exchange', desc: 'Generate ECC key pair, exchange public keys' },
      { step: 'API Key Assignment', desc: 'Obtain appId, configure Headers' },
      { step: 'Sandbox Development', desc: 'Implement signing, API calls, Webhook reception' },
      { step: 'Sandbox Integration', desc: 'Full scenario functional verification & signature verification' },
      { step: 'Production Configuration', desc: 'Switch Endpoint, update keys and callbackUrl' },
      { step: 'Production Launch', desc: 'Canary verification → full rollout' },
    ],

    doc_guideS10Title: 'Information Exchange Checklist',
    doc_guideS10FiatProvides: 'Fiat Channel Provides',
    doc_guideS10FiatItems: ['API Endpoint (Sandbox + Prod)', 'appId (API Key)', 'Webhook ECC Public Key', 'Webhook Source IP'],
    doc_guideS10BizProvides: 'Integrator Provides',
    doc_guideS10BizItems: ['Egress IP (for whitelist)', 'ECC Public Key (for request verification)', 'Webhook Receiving URL', 'Default Callback URL (offline deposit)'],

    // Webhook Tab
    doc_tabWebhook: 'Webhook',
    doc_webhookTitle: 'Webhook Async Callbacks',
    doc_webhookSubtitle: 'When transaction status changes, Fiat Payment platform will notify merchants asynchronously via Webhook.',
    doc_webhookSecurity: 'Webhook Security',
    doc_webhookSecurityDesc1: 'Webhook messages are signed by Fiat Payment platform private key',
    doc_webhookSecurityDesc2: 'Merchants must verify signatures using the platform public key',
    doc_webhookSecurityDesc3: 'Webhook messages are signed but not encrypted',
    doc_webhookRetry: 'Retry Mechanism',
    doc_webhookRetryDesc: 'Max retries: 5, with exponential backoff strategy',
    doc_webhookRetryWarning: 'Ensure your Webhook endpoint is idempotent to avoid duplicate processing. Return HTTP 200 to acknowledge receipt, otherwise retries will be triggered.',
    doc_webhookRequestBody: 'Webhook Request Body',
    doc_webhookFieldMsgId: 'Webhook message unique ID',
    doc_webhookFieldEventType: 'Event type',
    doc_webhookFieldVersion: 'Message version, fixed 1.0.0',
    doc_webhookFieldData: 'Business data (JSON string), structure varies by eventType',
    doc_webhookEventTypes: 'Event Types',
    doc_webhookEventAccount: 'Account Creation',
    doc_webhookEventCard: 'Bank Account Binding',
    doc_webhookEventDeposit: 'Deposit',
    doc_webhookEventWithdraw: 'Withdraw',
    doc_webhookEventRefund: 'Refund',
    doc_webhookEventUser: 'User Creation',
    doc_webhookDataStructure: 'data Structure',
    doc_webhookSelectEvent: 'Select event type to view data structure',
    doc_webhookFieldName: 'Field',
    doc_webhookFieldType: 'Type',
    doc_webhookFieldRequired: 'Required',
    doc_webhookFieldDesc: 'Description',
    doc_webhookVerifyTitle: 'Signature Verification',
    doc_webhookVerifyDesc: 'Use the Webhook public key provided by Fiat Channel to verify the body content with SHA384withECDSA.',
    doc_webhookVerifyWarning: 'Webhooks that fail verification must be rejected.',
    doc_webhookHeaderDesc: 'Webhook request Headers contain signature info:',
    doc_webhookExample: 'Example',
  },
};

// Field label translations for BASE_PARAMS and RESPONSE_PARAMS
// These map Chinese labels to English equivalents
export const fieldLabelMap = {
  // Base params
  '请求ID': 'Request ID',
  '外部用户ID': 'External User ID',
  '币种': 'Currency',
  '渠道代码': 'Channel Code',
  '支付方式': 'Payment Method',
  '用户类型': 'User Type',
  '扩展参数': 'Extended Params',
  '账户ID': 'Account ID',
  '账户姓名': 'Account Name',
  '银行编码': 'Bank Code',
  '卡号': 'Account Number',
  '银行名字': 'Bank Name',
  '银行国家': 'Bank Country',
  '账户类型': 'Account Type',
  '外部订单号': 'External Order ID',
  '金额': 'Amount',
  '充值方式': 'Deposit Method',
  '回调地址': 'Callback URL',
  '跳转地址': 'Redirect URL',
  '过期时间': 'Expiry Date',
  '提现方式': 'Withdraw Method',
  '关户原因': 'Close Reason',
  '绑卡ID': 'Recipient ID',
  '订单号': 'Order ID',
  '外部退款订单号': 'External Refund Order ID',
  '外部退款单号': 'External Refund Order ID',
  '充值订单号': 'Deposit Order ID',
  '订单类型': 'Order Type',
  '退款描述': 'Refund Description',
  '退款单号': 'Refund Order ID',
  '交易类型': 'Order Type',
  '订单状态': 'Order Status',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '页码': 'Page',
  '每页条数': 'Page Size',
  '国家代码': 'Country Code',
  '业务场景': 'Business Scene',
  '文件类型': 'Document Type',
  '业务ID': 'Business ID',
  '文件': 'File',
  '文件国家': 'Document Country',
  '文件面': 'Document Side',
  '文件ID列表': 'File ID List',
  '操作类型': 'Operation Type',
  '用户ID': 'User ID',
  '渠道账户号': 'Channel Account No.',
  '原始币种': 'Origin Currency',
  '目标币种': 'Target Currency',
  '收款人类型': 'Payee Type',
  // extParam labels from DB metadata
  '名': 'First Name',
  '中间名': 'Middle Name',
  '姓': 'Last Name',
  '全名': 'Full Name',
  '手机号': 'Phone',
  '生日': 'Birthday',
  '生日/注册日期': 'DOB / Registration Date',
  '邮箱': 'Email',
  '证件类型': 'ID Type',
  '证件号': 'ID Number',
  '证件号码': 'ID Number',
  '国籍': 'Nationality',
  '国家': 'Country',
  '居住国/注册国': 'Residence / Registration Country',
  '居住城市/注册城市': 'Residence / Registration City',
  '居住地址/注册地址': 'Residence / Registration Address',
  '城市': 'City',
  '街道': 'Street',
  '门牌号': 'House Number',
  '邮编': 'Postal Code',
  '企业类型': 'Business Type',
  '公司名': 'Company Name',
  '描述': 'Description',
  '银行标识': 'Bank Identifier',
  '银行代码': 'Bank Code',
  '银行Code': 'Bank Code',
  '银行流水': 'Bank Reference',
  '银行地址': 'Bank Address',
  '银行城市': 'Bank City',
  '银行州/省': 'Bank State/Province',
  '虚拟账户名': 'Virtual Account Name',
  '虚拟账户名称': 'Virtual Account Name',
  '绑卡类型': 'Bind Type',
  '收款人姓名': 'Recipient Name',
  '收款人电话': 'Recipient Phone',
  '收款人邮箱': 'Recipient Email',
  '收款人国家': 'Recipient Country',
  '收款人城市': 'Recipient City',
  '收款人地址': 'Recipient Address',
  '收款人地址行1': 'Recipient Address Line 1',
  '收款人邮编': 'Recipient Postal Code',
  '收款人税号': 'Recipient Tax ID',
  '付款用途': 'Payment Purpose',
  '付款原因': 'Payment Reason',
  '费用承担方': 'Charge Type',
  '提现目的': 'Withdraw Purpose',
  '提现备注': 'Withdraw Note',
  '转账描述': 'Transfer Description',
  '转账备注': 'Transfer Note',
  '附加备注': 'Additional Note',
  '目标金额': 'Target Amount',
  '汇率ID': 'Rate ID',
  '计算方向': 'Calculation Direction',
  '用途代码': 'Purpose Code',
  '清算网络': 'Clearing Network',
  '协议类型': 'Protocol Type',
  '路由类型': 'Routing Type',
  'ABA路由号': 'ABA Routing Number',
  '分行编号': 'Branch Code',
  '金融机构标识': 'Financial Institution ID',
  '用户名字': 'User Name',
  '用户姓名': 'User Name',
  '用户邮箱': 'User Email',
  '使用者名称': 'User Name',
  '客户姓名': 'Customer Name',
  '客户手机号': 'Customer Phone',
  '客户邮箱': 'Customer Email',
  '客户地址': 'Customer Address',
  '合作关系证明': 'Relationship Proof',
  '原因详情': 'Reason Detail',
  'PIX类型': 'PIX Type',
  'PIX账号': 'PIX Account',
  'CLABE号/借记卡号/手机号': 'CLABE / Debit Card / Phone',
  'BVN号码': 'BVN Number',
  'NIN号码': 'NIN Number',
  // Response labels
  '开户状态': 'Account Status',
  '子状态': 'Sub Status',
  '跳转链接': 'Redirect URL',
  '错误码': 'Error Code',
  '错误信息': 'Error Message',
  '创建时间': 'Create Time',
  '更新时间': 'Update Time',
  '账户详情': 'Account Detail',
  '绑卡状态': 'Bind Status',
  '银行户名': 'Bank Account Name',
  '状态': 'Status',
  '支付信息': 'Payment Info',
  '退款状态': 'Refund Status',
  '渠道': 'Channel',
  '手续费': 'Fee',
  '完成时间': 'Completed Time',
  '付款人信息': 'Sender Info',
  '收款人信息': 'Receiver Info',
  '支付类型': 'Pay Type',
  '类型': 'Type',
  '支付链接': 'Payment URL',
  '二维码内容': 'QR Code',
  '二维码图片': 'QR Code Image',
  '授权ID': 'Authorization ID',
  '授权Token': 'Authorization Token',
  '前端授权Token': 'App Authorization Token',
  '前端链接方式': 'Connect Type',
  '账户号码': 'Account No.',
  '账户名称': 'Account Name',
  '所属银行名称': 'Bank Name',
  'IBAN账号': 'IBAN',
  'VBAN账号': 'VBAN',
  '充值意图': 'Deposit Purpose',
  '备注': 'Remarks',
  '转账时间': 'Transfer Time',
  '地址': 'Address',
  '业务线订单号': 'External Order ID',
  '充值单状态': 'Deposit Status',
  '充值子状态': 'Deposit Sub Status',
  '提现单状态': 'Withdraw Status',
  '提现子状态': 'Withdraw Sub Status',
  '上游订单号': 'External Order ID',
  '绑定银行账户ID': 'Recipient ID',
  '渠道名称': 'Channel Name',
  '国际银行账户号码': 'IBAN',
  '法币币种': 'Fiat Currency',
  '收款人银行地址': 'Recipient Bank Address',
  '区域': 'Region',
  '渠道结算币种': 'Settlement Currency',
  '是否需要VA同名': 'Require VA Same Name',
  '是否需要开户': 'Need Account Opening',
  '充值订单模式': 'Deposit Order Mode',
  '支持部分退款': 'Support Partial Refund',
  '渠道编号': 'Channel Code',
  '合作伙伴': 'Business Partner',
  '账户号': 'Account ID',
  '银行唯一标识': 'Bank Identifier',
  '国际转账限额': 'International Transfer Limits',
  '用户退款到账金额': 'Refund Arrival Amount',
  '持有人名称': 'Holder Name',
  '二维码': 'Bar Code',
  '发送方账户': 'Sender Account No.',
  '发送方账户名称': 'Sender Account Name',
  'SWIFT/BIC Code': 'SWIFT/BIC Code',
  '发送方地址': 'Sender Address',
  '发送方国家代码': 'Sender Country Code',
  '渠道编码': 'Channel Code',
  '最小转账金额': 'Min Transfer Amount',
  '最大转账金额': 'Max Transfer Amount',
  '渠道订单ID': 'Channel Order ID',
  '原始金额': 'Original Amount',
  '手续费金额': 'Fee Amount',
  '订单使用渠道': 'Order Channel',
  '渠道开户账户ID': 'Channel Account ID',
  '支付币种': 'Payment Currency',
  '订单金额': 'Order Amount',
  '渠道扩展信息': 'Channel Extension Info',
  '目的': 'Purpose',
  '时间': 'Time',
  '账号': 'Account Number',
  '开户渠道': 'Account Channel',
  '开户币种': 'Account Currency',
  '最后更新时间': 'Last Updated',
  '账户名': 'Account Name',
  '银行所在国家': 'Bank Country',
  '开户子状态': 'Account Sub Status',
  '渠道用户ID': 'Channel User ID',
  '支付目的地ID': 'Payment Destination ID',
  '银行获取的用户全名': 'Full Name Retrieved from Bank',
  '同名校验结果': 'Name Match Result',
  '多个IBAN': 'Multiple IBANs',
  '退款原因': 'Refund Reason',
  '原订单金额': 'Original Amount',
  '退款到账金额': 'Refund Arrival Amount',
  '手续费币种': 'Fee Currency',
  '渠道订单号': 'Channel Order ID',
  '渠道类型': 'Channel Type',
  '需要开户': 'Need Account',
  '支持充值': 'Support Deposit',
  '支持提现': 'Support Withdraw',
  '支持退款': 'Support Refund',
  '总数': 'Total',
  '交易金额': 'Transaction Amount',
  '交易时间': 'Transaction Time',
  '是否退款': 'Is Refunded',
  '银行名称': 'Bank Name',
  '国家码': 'Country Code',
  '转账限额': 'Transfer Limits',
  '文件ID': 'File ID',
  // Tazapay 提交补充资料：extParam.documents 展开后的子字段标签，避免英文页面残留中文
  '补充文件清单': 'Supplement Documents',
  '文件地址': 'File URL',
  '文件名': 'File Name',
  '文件描述': 'File Description',
  '渠道ClientID': 'Channel Client ID',
  '失败原因': 'Failure Reason',
  '可用余额': 'Available Balance',
  '汇率': 'Exchange Rate',
  '状态码': 'Status Code',
  '业务状态码': 'Business Code',
  '响应消息': 'Message',
  '请求时间': 'Request Time',
  '业务数据': 'Business Data',
  '结果': 'Result',

  // ==================== Avenia (BRL / PIX) ====================
  '企业文档列表(必须传可下载URL)': 'Company Documents (download URL required)',
  'UBO 文档列表(必须传可下载URL)': 'UBO Documents (download URL required)',
  '企业文档列表(传可下载URL)': 'Company Documents (pass download URL)',
  'UBO 文档列表(传可下载URL)': 'UBO Documents (pass download URL)',
  '文件可下载地址': 'File Download URL',
  // 绑定收款账户（Beneficiary）
  'PIX Key': 'PIX Key',
  '收款人姓名/企业名': 'Account Holder / Company Name',
  '收款行代码': 'Bank Code',
  '分行代码': 'Branch Code',
  '收款账号': 'Account Number',
  '收款方税号': 'Beneficiary Tax ID',
  '收款方别名': 'Beneficiary Alias',
  '收款方描述': 'Beneficiary Description',
  // 提现
  '提现金额(BRL)': 'Withdraw Amount (BRL)',
  '绑卡ID（中台）': 'Recipient ID (platform)',
  '转账附言': 'Transfer Remark',
  '工单有效期(秒)': 'Ticket Validity (seconds)',
  // 充值
  '充值金额(BRL)': 'Deposit Amount (BRL)',
  // 创建用户（KYB）— 企业信息
  '公司名称': 'Company Name',
  '法定名称(全大写)': 'Company Legal Name (UPPERCASE)',
  '企业注册号': 'Company Registration Number',
  '企业税号(CNPJ)': 'Company Tax ID (CNPJ)',
  '业务活动描述': 'Business Activity Description',
  '开户原因': 'Reason For Account Opening',
  '资金与收入来源': 'Source Of Funds And Income',
  '员工人数区间': 'Number Of Employees',
  '预估年营收(USD)': 'Estimated Annual Revenue (USD)',
  '预估月交易额(USD)': 'Estimated Monthly Volume (USD)',
  '税务居民国': 'Country Of Tax Residence',
  '税务居民国下级行政区': 'Tax Residence Subdivision',
  '企业街道': 'Company Street',
  '企业城市': 'Company City',
  '企业州/省': 'Company State / Province',
  '企业邮编': 'Company Zip Code',
  '企业国家': 'Company Country',
  '官网': 'Website',
  '社交媒体': 'Social Media',
  'Email 类型 PIX Key': 'Email-type PIX Key',
  '企业文档列表': 'Company Documents',
  // 创建用户（KYB）— UBO
  'UBO 全名': 'UBO Full Name',
  'UBO 出生日期': 'UBO Date Of Birth',
  'UBO 税号国家': 'UBO Tax ID Country',
  'UBO 税号(CPF)': 'UBO Tax ID (CPF)',
  'UBO 持股比例': 'UBO Ownership Percentage',
  'UBO 控制角色': 'UBO Control Role',
  'UBO 证件签发国': 'UBO Document Issuing Country',
  'UBO 邮箱': 'UBO Email',
  'UBO 手机号': 'UBO Phone',
  'UBO 街道': 'UBO Street',
  'UBO 城市': 'UBO City',
  'UBO 州/省': 'UBO State / Province',
  'UBO 邮编': 'UBO Zip Code',
  'UBO 国家': 'UBO Country',
  'UBO 文档列表': 'UBO Documents',
  '沙箱模拟拒绝': 'Sandbox Force Reject',
};

// Tip translations
export const fieldTipMap = {
  '各渠道差异字段，JSON格式字符串，见下方': 'Channel-specific fields, JSON string format, see below',
  '幂等key': 'Idempotent key',
  '精确到小数点后两位': 'Precise to 2 decimal places',
  '正数，最大16位整数+2位小数': 'Positive, max 16 integer digits + 2 decimal places',
  '正数，AmountValid校验': 'Positive, AmountValid validation',
  '钱包支付成功后跳转页面': 'Redirect page after wallet payment success',
  '与orderId至少传一个': 'At least one of orderId required',
  '与externalOrderId至少传一个': 'At least one of externalOrderId required',
  '毫秒时间戳，最大支持一周': 'Epoch ms, max 1 week range',
  '毫秒时间戳': 'Epoch milliseconds',
  '最大100': 'Max 100',
  '2位或3位国家码': '2 or 3 letter country code',
  '单次最多50个': 'Max 50 per request',
  '200 表示成功': '200 means success',
  '000000 表示成功': '000000 means success',
  '如 success': 'e.g. success',
  '原样返回请求中的 requestId': 'Echoed from request requestId',
  '具体结构见各接口响应参数': 'See individual API response params',
  'true 表示关户成功': 'true means close successful',

  // === ACCOUNT_CREATE BASE_PARAMS ===
  'EQUALS_MONEY仅USD; LEAN_TECH仅AED; 其他渠道需checkSupportCurrency': 'EQUALS_MONEY: USD only; LEAN_TECH: AED only; others: checkSupportCurrency',
  'LEAN_TECH仅LEAN; BANKING_CIRCLE仅VIRTUAL_ACCOUNT; 其他: VIRTUAL_ACCOUNT / PIX / VIETQR / ZEN_WALLET / INTERACE_REQUEST / LEAN': 'LEAN_TECH: LEAN only; BANKING_CIRCLE: VIRTUAL_ACCOUNT only; others: VIRTUAL_ACCOUNT / PIX / VIETQR / ZEN_WALLET / INTERACE_REQUEST / LEAN',
  'LEAN_TECH仅INDIVIDUAL; 其他: INDIVIDUAL / BUSINESS / ADMINISTRATOR / ALL': 'LEAN_TECH: INDIVIDUAL only; others: INDIVIDUAL / BUSINESS / ADMINISTRATOR / ALL',
  '所有渠道均需传入，JSON格式字符串，见下方渠道差异字段': 'Required for all channels, JSON string format, see channel diff fields below',

  // === CARD_BIND BASE_PARAMS ===
  'BANK_FRICK/PYVIO外所有渠道必填': 'Required for all channels except BANK_FRICK/PYVIO',
  'EQUALS_MONEY/SGB/LEAN_TECH/KORAPAY必填; BANK_FRICK仅SWIFT必填; PYVIO仅USD必填': 'EQUALS_MONEY / SGB / LEAN_TECH / KORAPAY: required; BANK_FRICK: SWIFT only; PYVIO: USD only',
  'EQUALS_MONEY/SGB/LEAN_TECH/KORAPAY/PYVIO必填; BANK_FRICK/BANKING_CIRCLE仅bindType=BANKACCOUNT必填': 'EQUALS_MONEY / SGB / LEAN_TECH / KORAPAY / PYVIO: required; BANK_FRICK / BANKING_CIRCLE: bindType=BANKACCOUNT only',
  'BANKING_CIRCLE仅bindType=BANKACCOUNT必填，其余渠道均必填': 'BANKING_CIRCLE: bindType=BANKACCOUNT only; All other channels: required',
  '@Size(min=15,max=34); LEAN_TECH必填; BANK_FRICK/BANKING_CIRCLE仅bindType=IBAN必填': '@Size(min=15, max=34); LEAN_TECH: required; BANK_FRICK / BANKING_CIRCLE: bindType=IBAN only',
  'EQUALS_MONEY/SGB必填(2位); LEAN_TECH必填(3位); PYVIO/BANKING_CIRCLE必填(2位)': 'EQUALS_MONEY / SGB: required (2-letter); LEAN_TECH: required (3-letter); PYVIO / BANKING_CIRCLE: required (2-letter)',
  'BANK_FRICK/BANKING_CIRCLE必填: IBAN / BANKACCOUNT': 'Required for BANK_FRICK/BANKING_CIRCLE: IBAN / BANKACCOUNT',
  'EQUALS_MONEY/LEAN_TECH/BANK_FRICK/BANKING_CIRCLE/PYVIO必填，JSON格式字符串，见下方': 'Required for EQUALS_MONEY/LEAN_TECH/BANK_FRICK/BANKING_CIRCLE/PYVIO, JSON string format, see below',

  // === DEPOSIT_CREATE BASE_PARAMS ===
  'CurrencyEnum校验: USD / RUB / UAH / GBP / EUR / DKK / BRL / MXN / ARS / COP / AED / NGN / HKD / SGD / ALL': 'CurrencyEnum validation: USD / RUB / UAH / GBP / EUR / DKK / BRL / MXN / ARS / COP / AED / NGN / HKD / SGD / ALL',
  '正数，最大20位整数+2位小数': 'Positive, max 20 integer digits + 2 decimal places',
  'StrictCallbackUrl校验，allowHttp=true，不可为空': 'StrictCallbackUrl validation, allowHttp=true, cannot be empty',

  // === WITHDRAW_CREATE BASE_PARAMS ===
  'EQUALS_MONEY仅USD; LEAN_TECH仅AED; SGB需checkSupportCurrency; 其他渠道无特殊限制': 'EQUALS_MONEY: USD only; LEAN_TECH: AED only; SGB: checkSupportCurrency; others: no restriction',
  'EQUALS_MONEY仅USD; LEAN_TECH仅AED; INSWITCH仅BRL; SGB需checkSupportCurrency; TAZAPAY为holdingCurrency(扣款币种); 其他渠道无特殊限制': 'EQUALS_MONEY: USD only; LEAN_TECH: AED only; INSWITCH: BRL only; SGB: checkSupportCurrency; TAZAPAY: holdingCurrency (debit currency); others: no restriction',
  '正数，AmountValid校验; KORAPAY最低1000': 'Positive, AmountValid validation; KORAPAY minimum 1000',
  'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; 当前所有渠道实现均仅支持BANK_TRANSFER': 'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; currently all channels only support BANK_TRANSFER',
  'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; INSWITCH仅支持PIX_CODE; TAZAPAY仅支持BANK_TRANSFER': 'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; INSWITCH: PIX_CODE only; TAZAPAY: BANK_TRANSFER only',
  'EQUALS_MONEY / SGB / PYVIO / LEAN_TECH / KORAPAY / BANK_FRICK / BANKING_CIRCLE / INSWITCH / TAZAPAY': 'EQUALS_MONEY / SGB / PYVIO / LEAN_TECH / KORAPAY / BANK_FRICK / BANKING_CIRCLE / INSWITCH / TAZAPAY',
  '必须以http://或https://开头': 'Must start with http:// or https://',
  '所有渠道均需传入，JSON格式字符串，见下方': 'Required for all channels, JSON string format, see below',

  // === ACCOUNT_CLOSE BASE_PARAMS ===
  'DTO无@NotBlank，但业务逻辑需要': 'No @NotBlank in DTO, but required by business logic',

  // === ORDER_PAGE BASE_PARAMS ===
  '最小值1': 'Minimum 1',
  'Service层checkParams校验': 'Service layer checkParams validation',

  // === FILE_UPLOAD BASE_PARAMS ===
  'ID_CARD / PASSPORT / DRIVER_LICENSE / SELFIE / ADDRESS_PROOF 等': 'ID_CARD / PASSPORT / DRIVER_LICENSE / SELFIE / ADDRESS_PROOF etc.',
  'jpg/png/pdf，最大10MB': 'jpg/png/pdf, max 10MB',

  // === Existing BASE_PARAMS tips ===
  '2位国家码, EQUALS_MONEY/SGB/KORAPAY/PYVIO/BANKING_CIRCLE必填': '2-letter country code, required for EQUALS_MONEY/SGB/KORAPAY/PYVIO/BANKING_CIRCLE',
  'LEAN_TECH非必填, SGB/EQUALS_MONEY/KORAPAY必填': 'Optional for LEAN_TECH, required for SGB/EQUALS_MONEY/KORAPAY',
  'LEAN_TECH必填(15-34位)': 'Required for LEAN_TECH (15-34 chars)',
  'BANK_FRICK/BANKING_CIRCLE时生效: IBAN / BANKACCOUNT': 'Effective for BANK_FRICK/BANKING_CIRCLE: IBAN / BANKACCOUNT',
  '如 ["SUCCESS","FAILED"]': 'e.g. ["SUCCESS","FAILED"]',
  '目前仅支持 PYVIO': 'Currently supports PYVIO only',
  'PYVIO/TAZAPAY渠道必填，JSON格式字符串，见下方渠道差异字段': 'Required for PYVIO/TAZAPAY, JSON string format, see channel diff fields below',
  'PYVIO / TAZAPAY': 'PYVIO / TAZAPAY',
  'INDIVIDUAL / BUSINESS; TAZAPAY仅支持BUSINESS': 'INDIVIDUAL / BUSINESS; TAZAPAY only supports BUSINESS',
  '渠道有多个账号时可指定': 'Specify when channel has multiple accounts',
  '固定值 PYVIO': 'Fixed value: PYVIO',
  'PYVIO必填: BENEFICIARY / SUPPLIER': 'Required for PYVIO: BENEFICIARY / SUPPLIER',
  'payeeType=BENEFICIARY时必填': 'Required when payeeType=BENEFICIARY',
  // RESPONSE_PARAMS tips
  '开户需要跳转外部链接时返回': 'Returned when account opening requires external redirect',
  '开户失败时返回': 'Returned on account opening failure',
  '开户成功时返回': 'Returned on successful account opening',
  '失败时返回': 'Returned on failure',
  'IBAN时必须': 'Required for IBAN',
  'IBAN时必须; ISO 3166-1 alpha-3': 'Required for IBAN; ISO 3166-1 alpha-3',
  'PROCESSING，最终状态通过webhook回调': 'PROCESSING, final status via webhook callback',
  'OFFLINE_DEPOSIT / PRE_ORDER': 'OFFLINE_DEPOSIT / PRE_ORDER',
  '渠道返回的额外信息，JSON格式': 'Extra info from channel, JSON format',
  '非换汇场景与 amount 一致，换汇场景为 payout 币种金额': 'Same as amount in non-FX scenario, payout currency amount in FX scenario',
  '非换汇场景与 currency 一致，换汇场景为 payout 币种': 'Same as currency in non-FX scenario, payout currency in FX scenario',
  '原始 payout 金额': 'Original Payout Amount',
  '原始 payout 币种': 'Original Payout Currency',
  'ISO 三字母国家代码': 'ISO 3-letter country code',
  '根据渠道返回不同字段': 'Fields vary by channel',
  'IBAN 或 accountNumber': 'IBAN or accountNumber',
  'Bank Identifier Code (BIC)': 'Bank Identifier Code (BIC)',
  '含 accountName / accountNumber / bic / bankName / bankCountry / bankAddress': 'Contains accountName / accountNumber / bic / bankName / bankCountry / bankAddress',
  '含 payType / payUrl / qrCode 等（非VA模式）': 'Contains payType / payUrl / qrCode etc. (non-VA mode)',
  '含 payType / payUrl / qrCode（非VA模式）': 'Contains payType / payUrl / qrCode (non-VA mode)',
  '非VA模式充值时返回': 'Returned for non-VA deposit mode',
  'VA模式充值时返回（BANK_FRICK）': 'Returned for VA deposit mode (BANK_FRICK)',
  'payType=AUTHORIZATION_ID 时有值': 'Available when payType=AUTHORIZATION_ID',
  'payType=AUTHORIZATION_ID 时有值; REVERSE_ENGINEERING / OPEN_BANKING': 'Available when payType=AUTHORIZATION_ID; REVERSE_ENGINEERING / OPEN_BANKING',
  'VA模式，BANK_FRICK使用': 'VA mode, used by BANK_FRICK',
  'SUCCESS: 解绑成功': 'SUCCESS: unbind successful',
  '后续提现使用': 'Used for subsequent withdrawal',
  '时间戳': 'Timestamp',
  '格式: 0.0000000000': 'Format: 0.0000000000',
  '多个externalUserId可对应同一个clientId': 'Multiple externalUserIds can map to one clientId',
  'ISO 三字母': 'ISO 3-letter',
  '含 currency / min / max': 'Contains currency / min / max',
  // extParam tips from DB metadata
  'userType为BUSINESS时，公司名称拆解填充此字段': 'For BUSINESS userType, split company name into this field',
  '+区号开头': 'Start with country code (+)',
  'yyyy-MM-dd 或 yyyy/MM/dd': 'yyyy-MM-dd or yyyy/MM/dd',
  '格式: DDMMYYYY, INDIVIDUAL=生日, BUSINESS=注册日期': 'Format: DDMMYYYY, INDIVIDUAL=DOB, BUSINESS=registration date',
  'P=护照, N=身份证, BUSINESS时传null': 'P=Passport, N=ID Card, null for BUSINESS',
  'INDIVIDUAL=身份证/护照号, BUSINESS=公司注册号, 1-100字符': 'INDIVIDUAL=ID/Passport No., BUSINESS=Registration No., 1-100 chars',
  'ISO-3 国家代码, INDIVIDUAL=居住国, BUSINESS=注册国': 'ISO-3 country code, INDIVIDUAL=residence, BUSINESS=registration',
  'ISO-3 国家代码, ^[A-Z]{3}$': 'ISO-3 country code, ^[A-Z]{3}$',
  '虚拟账号所有者全名, <=140字符, ^[a-zA-Z0-9 /\\-?:().,+]*$': 'VA owner full name, <=140 chars, ^[a-zA-Z0-9 /\\-?:().,+]*$',
  '银行的唯一标识符（从卡列表获取）': 'Unique bank identifier (from bank list API)',
  '由绑卡接口返回的recipientId': 'recipientId returned from card bind API',
  '3位字符, 如 SAL(工资)': '3-char code, e.g. SAL (salary)',
  '可以与开户传一个': 'Can use the same as account creation',
  '长度不超过32位': 'Max 32 characters',
  '长度100以内': 'Max 100 characters',
  'currency和targetCurrency不一致时必传': 'Required when currency differs from targetCurrency',
  'TARGET2ORIGIN: 到账金额为targetAmount; ORIGIN2TARGET: 支付金额为amount': 'TARGET2ORIGIN: arrival amount=targetAmount; ORIGIN2TARGET: payment amount=amount',
  '仅RTGS支持, Y=收款人姓名显示为自己': 'RTGS only, Y=show own name as recipient',
  'BEN=收款方承担, OUR=付款方承担, SHA=共同承担': 'BEN=beneficiary bears, OUR=sender bears, SHA=shared',
  '非IBAN模式(BANKACCOUNT)时必填, 格式: BIC/SWIFT、SC+sortCode(UK)、FW+fedwire(US)等': 'Required for non-IBAN mode, format: BIC/SWIFT, SC+sortCode(UK), FW+fedwire(US) etc.',
  '默认LOCAL': 'Default: LOCAL',
  '外部转账必填': 'Required for external transfer',
  'SWIFT方式必须提供': 'Required for SWIFT method',
  '自定义户名': 'Custom account name',
  'VA账户显示名称，将显示在ATM/银行应用': 'VA display name, shown on ATM/banking app',
  '支付成功后跳转页面': 'Redirect page after payment success',
  '2位国家代码': '2-letter country code',
  '3位国家代码, BRL对应BRA': '3-letter country code, BRL maps to BRA',
  'BENEFICIARY=本人账户, SUPPLIER=第三方账户': 'BENEFICIARY=own account, SUPPLIER=third-party account',
  'userType=BUSINESS时必填, FI=金融机构, NON_FI=非金融机构': 'Required for BUSINESS, FI=financial institution, NON_FI=non-financial',
  'KYC传个人姓名, KYB传企业名称': 'KYC: personal name, KYB: company name',
  'KYC传本人BVN, KYB传对应董事BVN, 必须11位': 'KYC: personal BVN, KYB: director BVN, must be 11 digits',
  'personal=BVN号, personal_nin=NIN号, company=CAC号(RC或BN开头)': 'personal=BVN, personal_nin=NIN, company=CAC (RC or BN prefix)',
  'personal=BVN校验, personal_nin=NIN校验, company=CAC校验': 'personal=BVN validation, personal_nin=NIN validation, company=CAC validation',
  'personal_nin类型时使用, 必须11位': 'For personal_nin type, must be 11 digits',
  '个人=姓名, 企业=CAC上的公司名': 'Individual=name, Business=company name on CAC',
  'email和mobile必须至少一个有值': 'At least one of email or mobile required',
  '和email不能同时为空; 钱包方式(LINKAJA/OVO/GOPAY/DANA/SHOPEEPAY)必填, 格式: 62xxxxxxxxx 或 08xxxxxxxxxx': 'Cannot be empty with email; required for wallet methods, format: 62xxx or 08xxx',
  '和mobile不能同时为空': 'Cannot be empty with mobile',
  'CPF(11位) 或 CNPJ(14位)': 'CPF (11 digits) or CNPJ (14 digits)',
  'BRL: CPF(11位)/CNPJ(14位), ARS: DNI(8位)/CUIT(11位)': 'BRL: CPF(11)/CNPJ(14), ARS: DNI(8)/CUIT(11)',
  '对应accountType的PIX key': 'PIX key matching accountType',
  '默认clabe': 'Default: clabe',
  'protocol=clabe时传18位CLABE号, debitcard传借记卡号, phonenum传手机号': 'clabe=18-digit CLABE, debitcard=card number, phonenum=phone',
  'protocol为debitcard或phonenum时必填': 'Required for debitcard or phonenum protocol',
  'PSE方式必填': 'Required for PSE method',
  'PSE/KHIPU方式必填': 'Required for PSE/KHIPU method',
  'PSE方式必填(57开头), OXXOPay方式必填, ARS币种必填': 'Required for PSE (57 prefix), OXXOPay, or ARS currency',
  'KHIPU方式必填': 'Required for KHIPU method',
  'KHIPU方式可不提供': 'Optional for KHIPU method',
  'ARS币种必填': 'Required for ARS currency',
  'payeeType=BENEFICIARY时必须, fileId': 'Required when payeeType=BENEFICIARY, fileId',
  '根据币种和国家不同选择不同枚举值': 'Enum values vary by currency and country',
  'FIS=金融服务, TCS=电信, MWP=钱包支付, OAT=本人转账, IFS=信息服务, RNT=租金, LNC=贷款, PIN=个人投资, GDS=商品买卖': 'FIS=Financial, TCS=Telecom, MWP=Wallet, OAT=Own Transfer, IFS=Info, RNT=Rent, LNC=Loan, PIN=Investment, GDS=Goods',

  // ==================== Avenia (BRL / PIX) ====================
  '映射到渠道 ticketBrlPixOutput.pixMessage，收款方在银行流水里可见。【上限 100 字符】实测 101 字符渠道返回 400 InvalidFieldError: ticketBrlPixOutput.pixMessage is invalid（是拒单不是截断），故中台按上限校验、超长即拒。【字符集】只允许 ASCII 字母、数字、空格。标点（- _ . , / : # ( * + = \'）与带重音字符（ç ã 等）渠道一律拒绝，报错与超长共用同一句 pixMessage is invalid，故中台在下单同步段即拦下（含兼容别名 pixMessage 传入的值）。示例写 Invoice 20260827，不要写 Invoice 2026-0827。【兼容别名 pixMessage】旧字段名仍可解析，新接入请用 remark。【实现要点】该字段必须放在渠道 ticketBrlPixOutput 内——放 ticket 顶层渠道返回 201 但静默丢弃，工单明细回显为空（渠道文档 Option 3 示例写在顶层，与实际行为不符，以实测为准）。': 'Mapped to the channel\'s ticketBrlPixOutput.pixMessage; visible to the beneficiary on their bank statement. [Limit is 100 characters] Verified: 101 characters return 400 InvalidFieldError: ticketBrlPixOutput.pixMessage is invalid (a rejection, not a truncation), so the platform validates the length and rejects anything longer. [Character set] Only ASCII letters, digits and spaces are accepted. Punctuation (- _ . , / : # ( * + = \') and accented characters (c-cedilla, a-tilde and the like) are all rejected by the channel, which reuses the same "pixMessage is invalid" message for both the length and the character-set failure, so the platform blocks it synchronously at order creation (including values arriving via the pixMessage alias). Write Invoice 20260827, not Invoice 2026-0827. [Alias pixMessage still accepted] Use remark for new integrations. [Implementation note] The field must sit inside the channel\'s ticketBrlPixOutput object - placed at the ticket top level the channel returns 201 but silently drops it and the ticket detail echoes an empty value (the channel docs show it at top level under Option 3, which contradicts the observed behaviour; the verified behaviour wins).',
  '【形态一】收款方 PIX Key，与下方六项银行字段二选一。支持 CNPJ(14 位企业税号)/Email/Phone/EVP(UUID)。【CPF 会被拒绝】CPF（11 位个人税号）作为 pixKey 被中台拒绝（400，msg 含 CPF pix key is not supported），带格式符的 111.444.777-35 同样被拒；渠道侧本身不拦（实测 CPF 工单为 PAID）。Email/Phone/EVP 需渠道 pix-info 解析出的 taxId 为 14 位 CNPJ 才放行。【须真实存在】沙箱/生产中不存在的 Key 渠道返回 pixKey is invalid。': '[Option 1] Beneficiary PIX key; mutually exclusive with the six bank-account fields below. Accepts CNPJ (14-digit company tax ID), Email, Phone or EVP (UUID). [CPF is rejected] An 11-digit CPF is rejected by the platform (400, msg contains "CPF pix key is not supported"); the formatted form 111.444.777-35 is rejected too. The channel itself does NOT block CPF (verified: a CPF ticket settled as PAID). Email/Phone/EVP are only accepted when the tax ID resolved by the channel pix-info lookup is a 14-digit CNPJ. [Must already exist] Keys unknown to the sandbox/production PIX directory are rejected by the channel with "pixKey is invalid".',
  '【形态二】六项银行字段之一，须齐全（缺任一项返回 incomplete bank account fields）。账户持有人全名/企业名。': '[Option 2] One of the six bank-account fields; all six are required (missing any returns "incomplete bank account fields"). Full legal name of the account holder or company.',
  '【形态二】3 位银行代码或 8 位 ISPB，须是真实存在的银行。【实测】2601（4 位）返回 404 NotFoundError: bankCode not found；传 8 位 ISPB 30306294 登记成功但渠道回显归一化为 3 位 208。': '[Option 2] 3-digit bank code or 8-digit ISPB; must be a real, existing bank. [Verified] 2601 (4 digits) returns 404 NotFoundError: bankCode not found; an 8-digit ISPB such as 30306294 registers successfully but the channel echoes it back normalised to the 3-digit code 208.',
  '【形态二】银行分行编号（agência）': '[Option 2] Bank branch number (agencia).',
  '【形态二】银行账号（conta）': '[Option 2] Bank account number (conta).',
  '【形态二】仅四个取值：checking / payment / savings / salary。【大小写不敏感】SAVINGS 实测可登记且原样回显；current 之类返回 400 InvalidFieldError: accountType is invalid。中台出站统一转小写。': '[Option 2] Only four values: checking / payment / savings / salary. [Case-insensitive] SAVINGS registers successfully and is echoed back verbatim; values like "current" return 400 InvalidFieldError: accountType is invalid. The platform lower-cases the value before sending it upstream.',
  '【形态二】CPF(11 位) 或 CNPJ(14 位)。缺失渠道返回 400 InvalidFieldError: taxId is invalid。【本期只接受 CNPJ】11 位 CPF 被中台拒绝（msg 含 CPF taxId is not supported）；注意渠道不校验主体性质——CPF 实测同样 201 登记成功，中台是唯一防线。位数既非 11 也非 14 时中台直接拒绝。': '[Option 2] CPF (11 digits) or CNPJ (14 digits). Missing it returns 400 InvalidFieldError: taxId is invalid. [Only CNPJ accepted this phase] An 11-digit CPF is rejected by the platform (msg contains "CPF taxId is not supported"). Note the channel does not validate the entity type at all - a CPF registers successfully, so the platform is the only safeguard. Any length other than 11 or 14 is rejected by the platform.',
  '【渠道必填，中台可不传】渠道对不传/空串/101 字符均返回 400 InvalidFieldError: alias is invalid，故上游未传时中台兜默认值 AV-<PIX Key 或账号后 6 位>；上游传了则按 100 字符上限截断。仅用于渠道控制台展示，不参与付款。': '[Required by the channel, optional for callers] The channel returns 400 InvalidFieldError: alias is invalid for a missing value, an empty string, or 101 characters. When the caller omits it the platform supplies a default of AV-<last 6 digits of the PIX key or account number>; a caller-supplied value is truncated to 100 characters. Display-only in the channel console, never used for routing the payment.',
  '非必填，上限 255 字符。【实测 256 字符渠道拒绝】（InvalidFieldError: description is invalid，是拒单不是截断），故中台先按上限截断再出站。': 'Optional, up to 255 characters. [Verified: 256 characters are rejected] (InvalidFieldError: description is invalid - a rejection, not a truncation), so the platform truncates to the limit before sending.',
  '单位 BRL（巴西雷亚尔），须 > 0。【沙箱自动入金上限实测 R$1000（含）】R$1000 → 约 23 秒 PAID；R$1000.01 及以上 → 不自动付款，工单停在 UNPAID 直至过期（生产环境无此限制）。【到账耗时】实测 23~30 秒（含链上 txHash）。【费率】In Fee 0.25%：入 1000 → 到账 999.5 BRLA；入 1 → 到账 0.75 BRLA。': 'Amount in BRL (Brazilian real), must be greater than 0. [Sandbox auto-settlement cap verified at R$1000 inclusive] R$1000 settles as PAID in about 23 seconds; R$1000.01 and above are not auto-paid and the ticket stays UNPAID until it expires (no such cap in production). [Settlement time] 23-30 seconds including the on-chain txHash. [Fees] In Fee 0.25%: paying in 1000 credits 999.5 BRLA; paying in 1 credits 0.75 BRLA.',
  '收款方到账金额（渠道 outputAmount），单位 BRL，须 > 0，最多 2 位小数。【实际扣款 = amount + Out Fee】Out Fee 实测固定 0.25 BRLA，与金额无关：到账 0.01 扣 0.26、到账 1 扣 1.25、到账 500 扣 500.25，极小额提现手续费占比极高。【余额语义】中台余额与渠道 BRLA 余额是两套账：中台余额不足在冻结阶段即拒绝、不会打到渠道（终态 FAILED，errorMsg=Freeze channel balance failed）；渠道余额不足返回 blockchain execution failed: do you have enough balance?': 'Amount credited to the beneficiary (the channel\'s outputAmount), in BRL, must be greater than 0 with at most 2 decimal places. [Actual debit = amount + Out Fee] The Out Fee is a verified flat 0.25 BRLA regardless of size: crediting 0.01 debits 0.26, crediting 1 debits 1.25, crediting 500 debits 500.25 - the fee dominates very small payouts. [Two separate ledgers] The platform balance and the channel BRLA balance are independent: an insufficient platform balance is rejected at the freeze step and never reaches the channel (final state FAILED, errorMsg=Freeze channel balance failed); an insufficient channel balance returns "blockchain execution failed: do you have enough balance?"',
  '【唯一收款方式】中台绑卡 id，由 POST /v1/fiat/payment/bankaccount/bind 返回，形如 RP20260827AV00000029。缺失返回 400（msg 含 extParam.recipientId is required）。【须为 SUCCESS 状态】绑卡未完成/失败/已删的记录会被拒（Recipient is not Active）；绑卡成功但渠道侧 id 缺失时返回 Avenia beneficiary not bound for recipientId。【不要传渠道侧 id】渠道内部 id 由中台从绑卡记录解析后出站。': '[The only supported payout target] Platform recipient ID returned by POST /v1/fiat/payment/bankaccount/bind, e.g. RP20260827AV00000029. Omitting it returns 400 (msg contains "extParam.recipientId is required"). [Must be in SUCCESS state] Pending, failed or deleted bindings are rejected ("Recipient is not Active"); a binding that succeeded locally but lacks the channel-side ID returns "Avenia beneficiary not bound for recipientId". [Do not send the channel-side ID] The platform resolves the channel\'s internal ID from the binding record before calling the channel.',
  '映射到渠道 ticketBrlPixOutput.pixMessage，收款方在银行流水里可见。【上限 100 字符】实测 101 字符渠道返回 400 InvalidFieldError: ticketBrlPixOutput.pixMessage is invalid（是拒单不是截断），故中台按上限校验、超长即拒。【兼容别名 pixMessage】旧字段名仍可解析，新接入请用 remark。【实现要点】该字段必须放在渠道 ticketBrlPixOutput 内——放 ticket 顶层渠道返回 201 但静默丢弃，工单明细回显为空（渠道文档 Option 3 示例写在顶层，与实际行为不符，以实测为准）。': 'Mapped to the channel\'s ticketBrlPixOutput.pixMessage; visible to the beneficiary on their bank statement. [Limit is 100 characters] Verified: 101 characters return 400 InvalidFieldError: ticketBrlPixOutput.pixMessage is invalid (a rejection, not a truncation), so the platform validates the length and rejects anything longer. [Alias pixMessage still accepted] Use remark for new integrations. [Implementation note] The field must sit inside the channel\'s ticketBrlPixOutput object - placed at the ticket top level the channel returns 201 but silently drops it and the ticket detail echoes an empty value (the channel docs show it at top level under Option 3, which contradicts the observed behaviour; the verified behaviour wins).',

  // ---- Avenia USER_CREATE (KYB) ----
  '作为 Avenia subaccount 的 name，≤64 字符，超长直接拒绝': 'Used as the Avenia subaccount name; max 64 characters. Longer values are rejected outright rather than truncated, so the platform ledger name always matches the channel side.',
  '渠道要求全大写提交，平台校验非全大写即拒绝': 'The channel requires this in UPPERCASE. The platform rejects any value that is not fully uppercase rather than silently rewriting a legal entity name.',
  '企业注册号（巴西为 CNPJ 登记号/NIRE 等注册凭证编号），必填、非空即可，平台不做格式约束。与 taxIdentificationNumberTin（CNPJ 税号）是两个字段，勿混填。': 'Company registration number (in Brazil the CNPJ registration / NIRE certificate number). Required, non-blank; the platform applies no format constraint. This is a different field from taxIdentificationNumberTin (the CNPJ tax ID) - do not conflate them.',
  '巴西企业须为 14 位 CNPJ': 'Brazilian companies must supply a valid 14-digit CNPJ.',
  '1~2000 字符': '1 to 2000 characters.',
  '必须按商户真实业务传入，不得对所有商户硬编码为同一固定值；枚举校验': 'Must reflect the merchant\'s real business; do not hard-code a single fixed value for every merchant. Validated against the channel enum.',
  '按商户真实业务传入；枚举校验': 'Must reflect the merchant\'s real business. Validated against the channel enum.',
  '员工人数区间，必填，须为渠道枚举之一（枚举校验不通过平台直接拒绝，msg 含 numberOfEmployees invalid）。按商户真实规模传，勿对所有商户硬编码同一值。': 'Employee-count band, required, must be one of the channel enum values (a rejected enum returns msg containing "numberOfEmployees invalid"). Send the merchant\'s real band; do not hard-code one value for everyone.',
  '预估年营收区间（USD），必填，须为渠道枚举之一（不通过平台直接拒绝，msg 含 estimatedAnnualRevenueUsd invalid）。与 estimatedMonthlyVolumeUsd 不同：本字段是区间枚举，后者是整数字符串。': 'Estimated annual revenue band (USD), required, must be one of the channel enum values (a rejected enum returns msg containing "estimatedAnnualRevenueUsd invalid"). Note the difference from estimatedMonthlyVolumeUsd: this field is an enum band, that one is an integer string.',
  '整数字符串': 'Integer string.',
  'ISO alpha-3；无税务居民国可传 N/A': 'ISO alpha-3. Send N/A when there is no country of tax residence.',
  '税务居民国的下级行政区（州/省），非必填，平台不做校验。countryTaxResidence 传 N/A 时本字段一并留空即可。': 'State/province of the country of tax residence. Optional, not validated by the platform. Leave it empty when countryTaxResidence is N/A.',
  '提交渠道时映射为带前缀字段 companyStreetLine1(实测：不带 company 前缀会被拒)': 'Mapped to the prefixed channel field companyStreetLine1 when submitted (verified: without the company prefix the channel rejects the request).',
  '企业注册地址城市，必填、非空即可。': 'Company registered address city. Required, non-blank.',
  '企业注册地址州/省，必填、非空即可。': 'Company registered address state/province. Required, non-blank.',
  '企业注册地址邮编，必填、非空即可（巴西 CEP 为 8 位数字）。': 'Company registered address postal code. Required, non-blank (Brazilian CEP is 8 digits).',
  'ISO alpha-3': 'ISO alpha-3.',
  '企业官网，非必填，平台不做格式校验；有官网时建议提供，可加快合规审查。': 'Company website. Optional, no format validation; supplying it can speed up compliance review.',
  '企业社交媒体主页，非必填，平台不做格式校验。': 'Company social media profile. Optional, no format validation.',
  '企业的 Email 类型 PIX Key，非必填。仅作企业档案信息提交给渠道，**与提现收款方无关**——收款方 PIX Key 在绑卡接口（bankaccount/bind）传。': 'The company\'s Email-type PIX key. Optional, submitted to the channel as company profile data only. NOT related to the payout beneficiary - the beneficiary PIX key is supplied to the card-binding endpoint (bankaccount/bind).',
  '最小集：CERTIFICATE-OF-INCORPORATION(企业注册证明) + COMPANY-TAX-IDENTIFICATION-DOCUMENT(企业税号文件)，各 1 份、只能单面(isDoubleSided=false)。每项需 fileType + fileId + fileName。fileId 必须是先调 POST /v1/fiat/payment/file/upload 上传文件流后返回的 fileId，不是可下载 URL；中台按 fileId 查自己的 S3 存储地址读取文件内容再上传渠道。创建用户时会同步校验 fileId 存在且其上传时登记的 fileType 与此处声明一致。': 'Minimum set: CERTIFICATE-OF-INCORPORATION plus COMPANY-TAX-IDENTIFICATION-DOCUMENT, one each, single-sided only (isDoubleSided=false). Each entry needs fileType + fileId + fileName. The fileId must be the value returned by POST /v1/fiat/payment/file/upload after uploading the file stream - it is not a downloadable URL; the platform resolves its own S3 object key from the fileId, reads the bytes and forwards them to the channel. On user creation the platform also verifies the fileId exists and that the fileType recorded at upload time matches the one declared here.',
  'uboList 最多 50 个': 'uboList holds at most 50 entries.',
  'yyyy-MM-dd；年龄须 ≥18(含闰年 2/29 边界)，未满 18 直接拒绝': 'yyyy-MM-dd. Age must be at least 18 (leap-day 29 Feb boundaries handled); anyone under 18 is rejected outright.',
  '巴西 UBO 须为有效 CPF(11 位)': 'Brazilian UBOs must supply a valid 11-digit CPF.',
  '0~100 的字符串': 'String in the range 0 to 100.',
  '单个 UBO 可不传（实测省略返回 201），但**整个 uboList 至少要有一个 UBO 带合法角色**，否则平台前置拦截（msg 含 requires at least one UBO with a valid hasControl role），不会打到渠道。传了值就必须是合法枚举之一。（此前文档把本字段标为「必填」有误，会让上游误以为每个 UBO 都得填。）': 'Optional per UBO (verified: omitting it returns 201), but the uboList as a whole must contain at least one UBO with a valid control role, otherwise the platform blocks the request up front (msg contains "requires at least one UBO with a valid hasControl role") and never calls the channel. When supplied it must be one of the valid enum values. (Earlier docs marked this field as required, which wrongly implied every UBO needs it.)',
  'UBO 身份证件的签发国，必填、非空即可，ISO alpha-3（如 BRA）。与 countryOfTaxId（税号所属国）是两个字段，可能不同。': 'Issuing country of the UBO\'s identity document. Required, non-blank, ISO alpha-3 (e.g. BRA). This is a different field from countryOfTaxId (the country of the tax ID) and the two may differ.',
  '非必填（2026-08-27 沙箱实测更正：省略 email 的 UBO 渠道返回 201，此前文档标必填有误）。传了则必须是合法邮箱格式，否则平台拒绝（msg 含 .email invalid）。建议尽量提供——合规审查时联系不上 UBO 会拖慢 KYB。': 'Optional (corrected 2026-08-27 by sandbox testing: a UBO without an email returns 201; the earlier "required" marking was wrong). When supplied it must be a valid email address, otherwise the platform rejects it (msg contains ".email invalid"). Supplying it is still recommended - compliance review slows down when a UBO cannot be reached.',
  '非必填（实测省略返回 201）。传了则必须是 E.164 格式（+ 国家码 + 号码，如 +5511999999999），否则平台拒绝（msg 含 .phone must be E.164 format）。': 'Optional (verified: omitting it returns 201). When supplied it must be E.164 format (plus sign, country code, number, e.g. +5511999999999), otherwise the platform rejects it (msg contains ".phone must be E.164 format").',
  'UBO 居住地址街道，必填、非空即可。': 'UBO residential address street. Required, non-blank.',
  'UBO 居住地址城市，必填、非空即可。': 'UBO residential address city. Required, non-blank.',
  'UBO 居住地址州/省，必填、非空即可。': 'UBO residential address state/province. Required, non-blank.',
  'UBO 居住地址邮编，必填、非空即可。': 'UBO residential address postal code. Required, non-blank.',
  'UBO 居住地址国家，必填、非空即可，ISO alpha-3（如 BRA）。': 'UBO residential address country. Required, non-blank, ISO alpha-3 (e.g. BRA).',
  '每个 UBO 至少 1 份身份证件(ID / DRIVERS-LICENSE / PASSPORT / RESIDENCE-PERMIT，可 isDoubleSided=true 并配 backFileId/backFileName)；可选 SELFIE-FROM-LIVENESS 活体自拍(固定单面，以 uploadedSelfieId 引用)。fileId / backFileId 均为 POST /v1/fiat/payment/file/upload 返回的 fileId，不是可下载 URL。': 'Each UBO needs at least one identity document (ID / DRIVERS-LICENSE / PASSPORT / RESIDENCE-PERMIT, optionally with isDoubleSided=true plus backFileId/backFileName); a SELFIE-FROM-LIVENESS selfie is optional (always single-sided, referenced as uploadedSelfieId). Both fileId and backFileId are values returned by POST /v1/fiat/payment/file/upload - they are not downloadable URLs.',
  '仅非生产环境透传给渠道用于模拟 KYB 拒绝；生产环境无论上游传什么都不发送该字段': 'Forwarded to the channel in non-production environments only, to simulate a KYB rejection. In production the field is never sent regardless of what the caller passes.',
  '可直接填入支持 URL 附件的渠道业务请求；调用方须确保异步处理期间该 http(s) URL 仍可下载，平台不约定固定有效期': 'Can be used in channel requests that support URL attachments. The caller must keep the HTTP(S) URL downloadable during asynchronous processing; the platform does not prescribe a fixed validity period.',
  '企业文档列表，最小集：CERTIFICATE-OF-INCORPORATION(企业注册证明) + COMPANY-TAX-IDENTIFICATION-DOCUMENT(企业税号文件)，各 1 份、只能单面(isDoubleSided=false)。每项需 fileType + fileId + fileName。【fileId 传可下载 URL】(2026-08-27 变更) 直接传业务方自己的文件可下载地址（http/https，如 pre-signed S3 URL），中台按该地址下载文件内容后转投渠道，与 PYVIO / TAZAPAY / MDAQ / MOOLAHGO 等渠道口径一致，**无需**先调文件上传接口。【兼容旧值】仍支持传中台 fileId（文件上传接口返回值），中台按 fileId 从自有 S3 读取；两种形态可混用，按是否以 http(s) 开头自动识别。【URL 要求】中台服务端可直接 GET 下载、返回 200 且响应体为文件字节；下载超时为连接 10 秒 / 读取 30 秒；下载失败会让创建用户终态失败并透传原因，故请确保调用创建用户时 URL 仍有效（pre-signed URL 注意剩余有效期）。【格式限制】渠道 accepted formats 仅 PNG / JPEG / PDF，其他格式会让渠道文档停在 EXPIRED、KYB 永远无法通过。': 'Company documents. Minimum set: CERTIFICATE-OF-INCORPORATION plus COMPANY-TAX-IDENTIFICATION-DOCUMENT, one each, single-sided only (isDoubleSided=false). Each entry needs fileType + fileId + fileName. [Pass a download URL in fileId] (changed 2026-08-27) Send your own downloadable file address (http/https, e.g. a pre-signed S3 URL); the platform fetches the bytes from that address and forwards them to the channel, matching how PYVIO / TAZAPAY / MDAQ / MOOLAHGO work - there is NO need to call the file upload endpoint first. [Legacy values still work] A platform fileId (returned by the file upload endpoint) is still accepted and read from the platform\'s own S3; the two forms can be mixed and are detected automatically by the http(s) prefix. [URL requirements] The platform server must be able to GET the address directly, receive 200 and a file body; download timeouts are 10s connect / 30s read. A failed download makes user creation fail with the reason propagated, so make sure the URL is still valid when you call user creation (mind the remaining lifetime of pre-signed URLs). [Format limits] The channel accepts PNG / JPEG / PDF only; anything else leaves the channel document stuck at EXPIRED and KYB can never pass.',
  '每个 UBO 至少 1 份身份证件(ID / DRIVERS-LICENSE / PASSPORT / RESIDENCE-PERMIT，可 isDoubleSided=true 并配 backFileId/backFileName)；可选 SELFIE-FROM-LIVENESS 活体自拍(固定单面，以 uploadedSelfieId 引用)。【fileId / backFileId 传可下载 URL】(2026-08-27 变更) 同企业文档：直接传 http/https 可下载地址，中台下载后转投渠道，**无需**先调文件上传接口；仍兼容传中台 fileId。【格式限制】仅 PNG / JPEG / PDF。': 'Each UBO needs at least one identity document (ID / DRIVERS-LICENSE / PASSPORT / RESIDENCE-PERMIT, optionally with isDoubleSided=true plus backFileId/backFileName); a SELFIE-FROM-LIVENESS selfie is optional (always single-sided, referenced as uploadedSelfieId). [Pass a download URL in fileId / backFileId] (changed 2026-08-27) Same as company documents: send an http/https downloadable address and the platform fetches it before forwarding to the channel - no need to call the file upload endpoint first; a platform fileId is still accepted. [Format limits] PNG / JPEG / PDF only.',
  '企业文档列表，最小集：CERTIFICATE-OF-INCORPORATION(企业注册证明) + COMPANY-TAX-IDENTIFICATION-DOCUMENT(企业税号文件)，各 1 份、只能单面(isDoubleSided=false)。每项需 fileType + fileId + fileName。【fileId 必须传可下载 URL】(2026-08-27 变更) 传业务方自己的文件可下载地址(http/https，如 pre-signed S3 URL)，中台按该地址下载内容后转投渠道，与 PYVIO / TAZAPAY / MDAQ / MOOLAHGO 等渠道口径一致，**无需**先调文件上传接口。传中台 fileId 会被拒绝(400，msg 含 must be a downloadable http(s) url)。【URL 要求】中台服务端可直接 GET 下载、返回 200 且响应体为文件字节；下载超时为连接 10 秒 / 读取 30 秒；下载失败或内容格式不符会让创建用户终态失败并透传原因，故请确保调用创建用户时 URL 仍有效(pre-signed URL 注意剩余有效期)。【格式限制且会校验】渠道 accepted formats 仅 PNG / JPEG / PDF，中台下载后按**文件头魔数**校验真实格式(不看 URL 后缀与响应 Content-Type)，不合格即拒；超范围格式若推给渠道会让渠道文档停在 EXPIRED、KYB 永远无法通过，且失败点在流水线中途——此时渠道子账户已创建且不支持删除，只能建全新子账户重来。': 'Company documents. Minimum set: CERTIFICATE-OF-INCORPORATION plus COMPANY-TAX-IDENTIFICATION-DOCUMENT, one each, single-sided only (isDoubleSided=false). Each entry needs fileType + fileId + fileName. [fileId MUST be a download URL] (changed 2026-08-27) Send your own downloadable file address (http/https, e.g. a pre-signed S3 URL); the platform fetches the content from it and forwards it to the channel, matching PYVIO / TAZAPAY / MDAQ / MOOLAHGO - there is NO need to call the file upload endpoint first. A platform fileId is rejected (400, msg contains must be a downloadable http(s) url). [URL requirements] The platform server must be able to GET the address directly, receive 200 and a file body; timeouts are 10s connect / 30s read. A failed download or a content-format mismatch makes user creation fail with the reason propagated, so make sure the URL is still valid when you call user creation (mind the remaining lifetime of pre-signed URLs). [Formats are enforced] The channel accepts PNG / JPEG / PDF only; after downloading, the platform verifies the real format by file header magic bytes (ignoring the URL suffix and the response Content-Type) and rejects anything else. Pushing an out-of-range format to the channel leaves the channel document stuck at EXPIRED so KYB can never pass, and the failure lands mid-pipeline - by then the channel sub-account exists and cannot be deleted, so you must start over with a new one.',
  '每个 UBO 至少 1 份身份证件(ID / DRIVERS-LICENSE / PASSPORT / RESIDENCE-PERMIT，可 isDoubleSided=true 并配 backFileId/backFileName)；可选 SELFIE-FROM-LIVENESS 活体自拍(固定单面，以 uploadedSelfieId 引用)。【fileId / backFileId 必须传可下载 URL】(2026-08-27 变更) 同企业文档：传 http/https 可下载地址，中台下载后转投渠道，**无需**先调文件上传接口；传中台 fileId 会被拒绝。【格式限制且会校验】仅 PNG / JPEG / PDF，中台按文件头魔数校验真实格式。': 'Each UBO needs at least one identity document (ID / DRIVERS-LICENSE / PASSPORT / RESIDENCE-PERMIT, optionally with isDoubleSided=true plus backFileId/backFileName); a SELFIE-FROM-LIVENESS selfie is optional (always single-sided, referenced as uploadedSelfieId). [fileId / backFileId MUST be a download URL] (changed 2026-08-27) Same as company documents: send an http/https downloadable address and the platform fetches it before forwarding to the channel - no need to call the file upload endpoint first; a platform fileId is rejected. [Formats are enforced] PNG / JPEG / PDF only, verified by file header magic bytes after download.',
};
